webpackJsonp([19],{

/***/ 5:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(8);


/**
 * 获取当前环境（默认beta）
 * @return {[type]} bete/prod [当前环境]
 */
function getEnv() {
    var env = 'beta';
    // 判断环境
    for (var envName in __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].env) {
        // eslint-disable-line
        if (location.host === __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].env[envName].domain) {
            env = envName;
        }
    }
    return env;
}

/* harmony default export */ __webpack_exports__["a"] = (getEnv);

/***/ }),

/***/ 60:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["openAppLogin"] = openAppLogin;
/* harmony export (immutable) */ __webpack_exports__["gotoH5Link"] = gotoH5Link;
/* harmony export (immutable) */ __webpack_exports__["openUrl"] = openUrl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dp_knb__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dp_knb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__dp_knb__);


function openAppLogin(url) {
    var link = 'bizmeituan://e.meituan.com/login_webview_backhomepage?url=' + encodeURIComponent(url);
    setTimeout(function () {
        return location.href = link;
    }, 300);
}

function gotoH5Link(from, to, replace, params) {
    var link = location.protocol + '//' + location.host + location.pathname.replace(from, to);
    if (params) link += '?' + params;
    setTimeout(function () {
        if (replace) {
            location.replace(link);
        } else {
            location.href = link;
        }
    }, 300);
}

function openUrl(from, to, replace, params) {
    var link = location.protocol + '//' + location.host + location.pathname.replace(from, to);
    if (params) link += '?' + params;
    setTimeout(function () {
        if (replace && __WEBPACK_IMPORTED_MODULE_0__dp_knb___default.a.jumpWebview) __WEBPACK_IMPORTED_MODULE_0__dp_knb___default.a.jumpWebview({ url: link });else __WEBPACK_IMPORTED_MODULE_0__dp_knb___default.a.openWebview({ url: link });
    }, 300);
}

/***/ }),

/***/ 7:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Ajax; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getUrlParam; });
/* unused harmony export throttle */
/* unused harmony export hideNavigationBar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return forbidDebounce; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getParams; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getUserInfo; });
/* unused harmony export cookie */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return callApp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isApp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isTest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return formatDate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dp_knb__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dp_knb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__dp_knb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__path_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__env_js__ = __webpack_require__(5);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable import/extensions */





__WEBPACK_IMPORTED_MODULE_0_axios___default.a.defaults.withCredentials = true;

var pathObj = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__path_js__["a" /* getPath */])();

var ua = navigator.userAgent.toLocaleLowerCase();

var isAndroid = ua.indexOf('android') > 0;

var isIos = /iphone|ipad|ipod|ios/.test(ua);

var isApp = /merchant/.test(ua);

var isTest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__env_js__["a" /* default */])() !== 'prd';

/**
 * [getAjaxUrl description]
 * @param  {[type]} url       [description]
 * @return {[type]}           [description]
 */
function getAjaxUrl(options) {
    if (/^https?:\/\//g.test(options.url)) {
        return options.url;
    }
    return pathObj.ajax + '/' + options.url;
}

function successHandle(response, options) {
    if (response && response.data) {
        if (options.success) {
            options.success(response.data);
        }
    } else if (options.error) {
        options.error(response);
    }
}

function errorHandle(error, options) {
    if (error.response) {
        if (error.response.status === 401) {
            console.log('401');
        } else if (error.response.status === 403) {
            console.log('403');
        } else if (options.error) {
            options.error(error);
        }
    } else if (options.error) {
        options.error(error);
    }
}

/**
 * [ajax封装，包括环境域名判断，路径拼接，sso跳转]
 * @param  {[type]} options []
 * options.url
 * options.params
 * options.success
 * options.error
 * @return {[type]}[description]
 */
var Ajax = {
    get: function get(options) {
        var header = _extends({
            'X-Requested-With': 'XMLHttpRequest'
        }, options.headers || {});
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(getAjaxUrl(options), {
            params: options.params,
            headers: header
        }).then(function (response) {
            successHandle(response, options);
        }, function (error) {
            errorHandle(error, options);
        }).catch(function (error) {
            errorHandle(error, options);
        });
    },
    post: function post(options) {
        var header = _extends({
            'Content-Type': 'application/json;charset=UTF-8',
            'X-Requested-With': 'XMLHttpRequest'
        }, options.headers || {});
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(getAjaxUrl(options), options.params, { headers: header }).then(function (response) {
            successHandle(response, options);
        }, function (error) {
            errorHandle(error, options);
        }).catch(function (error) {
            errorHandle(error, options);
        });
    },
    delete: function _delete(options) {
        var header = {
            'X-Requested-With': 'XMLHttpRequest'
        };
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.delete(getAjaxUrl(options), {
            headers: header
        }).then(function (response) {
            successHandle(response, options);
        }, function (error) {
            errorHandle(error, options);
        }).catch(function (error) {
            errorHandle(error, options);
        });
    },
    put: function put(options) {
        var header = {
            'Content-Type': 'application/json;charset=UTF-8',
            'X-Requested-With': 'XMLHttpRequest'
        };
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.put(getAjaxUrl(options), options.params, { headers: header }).then(function (response) {
            successHandle(response, options);
        }, function (error) {
            errorHandle(error, options);
        }).catch(function (error) {
            return errorHandle(error, options);
        });
    }
};

function getUrlParam(paramName) {
    var search = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : location.search;

    var paramList = {};
    if (search) {
        search.substr(1, search.length - 1).split('&').forEach(function (param) {
            var p = param.split('=');
            paramList[p[0]] = p[1];
        });
    }
    return paramList[paramName] || '';
}

/**
 * base64图片格式处理
 * @param localId
 * @returns {string}
 */
function processImage(localId) {
    var index = localId.indexOf('base64,');
    return localId.substr(index + 7, localId.length - index - 7);
}

function throttle(fn, wait) {
    var time = Date.now();
    return function () {
        if (time + wait - Date.now() < 0) {
            fn();
            time = Date.now();
        }
    };
}

function hideNavigationBar() {
    __WEBPACK_IMPORTED_MODULE_1__dp_knb___default.a.setNavigationBarHidden({
        flag: 1 // 0表示显示，1表示隐藏
    });
}
function forbidDebounce() {
    __WEBPACK_IMPORTED_MODULE_1__dp_knb___default.a.setBouncesEnabled({
        enabled: 0 // 1表示允许反弹，0表示禁止。default: 1
    });
}
function getUserInfo() {
    return __WEBPACK_IMPORTED_MODULE_1__dp_knb___default.a.uaInfo();
}

function getParams(name) {
    var searchArr = location.search.slice(1).split('&');
    var searchItem = searchArr.filter(function (item) {
        return item.indexOf(name) >= 0;
    })[0];
    return searchItem && searchItem.split('=')[1];
}

function cookie(key, value, options) {
    var cookie = void 0,
        cookies = void 0,
        len = void 0,
        name = void 0,
        result = false;

    if (arguments.length > 1) {
        options = options || {};
        if (typeof options.expires === 'number') {
            var hours = options.expires,
                t = options.expires = new Date();
            t.setMilliseconds(t.getMilliseconds() + 1000 * 60 * 60 * hours);
        }
        return document.cookie = [key, '=', value, options.expires ? '; expires=' + options.expires.toUTCString() : '', options.path ? '; path=' + options.path : '', options.domain ? '; domain=' + options.domain : '', options.secure ? '; secure' : ''].join('');
    } else {
        if (!key) return false;
        cookies = document.cookie ? document.cookie.split('; ') : [];
        len = cookies.length;

        for (var i = 0; i < len; i++) {
            cookie = cookies[i].split('=');
            name = cookie.shift();

            if (name === key) {
                result = cookie.join('');
                break;
            }
        }
        return result;
    }
}

function callApp(appUrl, h5Url) {
    var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2000;

    if (isAndroid) {
        var div = document.createElement('div');
        div.style.visibility = 'hidden';
        div.innerHTML = '<iframe id="schema" src="' + appUrl + '" scrolling="no" width="1" height="1"></iframe>';
        document.body.appendChild(div);
    } else if (isIos) {
        setTimeout(function () {
            window.location = appUrl;
            // let b = document.createElement('a');
            // b.setAttribute('href', appUrl),
            // b.style.display = 'none',
            // document.body.appendChild(b);
            // let c = document.createEvent('HTMLEvents');
            // c.initEvent('click', !1, !1),
            // b.dispatchEvent(c);
        }, 10);
    }

    if (h5Url) {
        setTimeout(function () {
            window.location = h5Url;
        }, timeout);
    }
}

function formatDate(date) {
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    if (month < 10) month = '0' + month;
    if (day < 10) day = '0' + day;
    var ret = year + '-' + month + '-' + day;
    return ret;
}



/***/ }),

/***/ 721:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_utils_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_app__ = __webpack_require__(60);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/style-prop-object */
/**
 * 用户隐私协议
 */



/* eslint-disable*/



/* eslint-disable class-methods-use-this */

var Agreement = function (_Component) {
  _inherits(Agreement, _Component);

  _createClass(Agreement, null, [{
    key: 'run',
    value: function run() {
      __WEBPACK_IMPORTED_MODULE_1_react_dom__["default"].render(__WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(Agreement, null), document.getElementById('app'));
    }
  }]);

  function Agreement() {
    _classCallCheck(this, Agreement);

    var _this = _possibleConstructorReturn(this, (Agreement.__proto__ || Object.getPrototypeOf(Agreement)).call(this));

    _this.jumpToAuthcall = _this.jumpToAuthcall.bind(_this);
    _this.jumpToSdkcontents = _this.jumpToSdkcontents.bind(_this);
    return _this;
  }

  _createClass(Agreement, [{
    key: 'jumpToAuthcall',
    value: function jumpToAuthcall() {
      var url = location.protocol + '//' + location.host + location.pathname.replace('useragreement', 'authcall');
      setTimeout(function () {
        if (__WEBPACK_IMPORTED_MODULE_2__lib_utils_js__["c" /* isApp */]) {
          __WEBPACK_IMPORTED_MODULE_3__lib_app__["openUrl"]('useragreement', 'authcall');
        } else {
          location.href = url;
        }
      }, 200);
    }
  }, {
    key: 'jumpToSdkcontents',
    value: function jumpToSdkcontents() {
      var url = location.protocol + '//' + location.host + location.pathname.replace('useragreement', 'sdkcontents');
      setTimeout(function () {
        if (__WEBPACK_IMPORTED_MODULE_2__lib_utils_js__["c" /* isApp */]) {
          __WEBPACK_IMPORTED_MODULE_3__lib_app__["openUrl"]('useragreement', 'sdkcontents');
        } else {
          location.href = url;
        }
      }, 200);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
        'div',
        { style: 'font-family: \u5B8B\u4F53; color: rgb(0, 0, 0);' },
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            align: 'center',
            style: 'margin: 5pt 0pt; text-align: center; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-family: \u5FAE\u8F6F\u96C5\u9ED1; font-size: 13.5pt;' },
            '\u7F8E\u56E2\u6392\u961F\u9690\u79C1\u653F\u7B56'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 0pt 0pt 0.0001pt; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 12pt;' },
            '\xA0'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 10.5pt;' },
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'font',
              { face: '\u5B8B\u4F53' },
              '\u7248\u672C\u53D1\u5E03\u65E5\u671F\uFF1A'
            ),
            ' 202'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 10.5pt;' },
            '3'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 10.5pt;' },
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'font',
              { face: '\u5B8B\u4F53' },
              '\u5E74'
            ),
            " "
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 10.5pt;' },
            '\xA0'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 10.5pt;' },
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'font',
              { face: '\u5B8B\u4F53' },
              '1\u6708'
            ),
            " "
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 10.5pt;' },
            '\xA0'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 10.5pt;' },
            '10\u65E5'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 13.5pt;' },
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement('br', null)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 10.5pt;' },
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'font',
              { face: '\u5B8B\u4F53' },
              '\u7248\u672C\u751F\u6548\u65E5\u671F\uFF1A'
            ),
            ' 202'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 10.5pt;' },
            '3'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 10.5pt;' },
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'font',
              { face: '\u5B8B\u4F53' },
              '\u5E74'
            ),
            " "
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 10.5pt;' },
            '\xA0'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 10.5pt;' },
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'font',
              { face: '\u5B8B\u4F53' },
              '1\u6708'
            ),
            " "
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 10.5pt;' },
            '\xA0'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 10.5pt;' },
            '17\u65E5'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 0pt 0pt 0.0001pt; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 12pt;' },
            '\xA0'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'font',
              { face: '\u5B8B\u4F53' },
              '\u7F8E\u56E2\u6392\u961F\uFF08\u4EE5\u4E0B\u6216\u79F0'
            ),
            '\u201C\u6211\u4EEC\u201D\uFF09\u975E\u5E38\u6CE8\u91CD\u4FDD\u62A4\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u6211\u4EEC\u6DF1\u77E5\u4E2A\u4EBA\u4FE1\u606F\u7684\u91CD\u8981\u6027\uFF0C\u5E76\u5C06\u6309\u7167\u6CD5\u5F8B\u6CD5\u89C4\u8981\u6C42\u548C\u4E1A\u754C\u6210\u719F\u7684\u5B89\u5168\u6807\u51C6\uFF0C \u91C7\u53D6\u76F8\u5E94\u7684\u5B89\u5168\u4FDD\u62A4\u63AA\u65BD\u6765\u4FDD\u62A4\u5546\u6237\uFF08\u4EE5\u4E0B\u6216\u79F0\u201C\u60A8\u201D\uFF09\u63D0\u4F9B\u7ED9\u6211\u4EEC\u6216\u6211\u4EEC\u5411\u60A8\u6536\u96C6\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 0pt 0pt 0.0001pt; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 12pt;' },
            '\xA0'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'u',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
                'span',
                { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
                __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
                  'font',
                  { face: '\u5B8B\u4F53' },
                  '\u3010\u7279\u522B\u63D0\u793A\u3011\u8BF7\u60A8\u5728\u4F7F\u7528\u6211\u4EEC\u63D0\u4F9B\u7684\u5404\u9879\u4EA7\u54C1'
                ),
                '/\u670D\u52A1\u524D\uFF0C\u4ED4\u7EC6\u9605\u8BFB\u5E76\u5145\u5206\u7406\u89E3\u672C\u300A\u9690\u79C1\u653F\u7B56\u300B\uFF08\u91CD\u70B9\u5185\u5BB9\u6211\u4EEC\u5DF2\u5C06\u5B57\u4F53\u52A0\u7C97\u8BF7\u60A8\u7279\u522B\u5173\u6CE8\uFF09\u5E76\u4F5C\u51FA\u76F8\u5E94\u9009\u62E9'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'u',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
              __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
                'font',
                { face: '\u5B8B\u4F53' },
                '\u3002'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'u',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
                'span',
                { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
                __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
                  'font',
                  { face: '\u5B8B\u4F53' },
                  '\u4E00\u65E6\u60A8\u4F7F\u7528\u6216\u7EE7\u7EED\u4F7F\u7528\u6211\u4EEC\u7684\u4EA7\u54C1'
                ),
                '/\u670D\u52A1\u65F6\uFF0C\u5373\u610F\u5473\u7740\u60A8\u540C\u610F\u6211\u4EEC\u6309\u7167\u672C\u9690\u79C1\u653F\u7B56\u6536\u96C6\u3001\u4F7F\u7528\u3001\u4FDD\u5B58\u3001\u5171\u4EAB\u548C\u4FDD\u62A4\u60A8\u7684\u76F8\u5173\u4FE1\u606F\u3002'
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 13.5pt;' },
            '\xA0'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'u',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
                'span',
                { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
                __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
                  'font',
                  { face: '\u5B8B\u4F53' },
                  '\u5982\u5BF9\u672C\u9690\u79C1\u653F\u7B56\u6709\u4EFB\u4F55\u7591\u95EE\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u672C\u9690\u79C1\u653F\u7B56'
                ),
                '\u201C\u5982\u4F55\u8054\u7CFB\u6211\u4EEC\u201D\u4E2D\u63D0\u4F9B\u7684\u65B9\u5F0F\u4E0E\u6211\u4EEC\u8054\u7CFB\u3002'
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 0pt 0pt 0.0001pt; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 12pt;' },
            '\xA0'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'font',
              { face: '\u5B8B\u4F53' },
              '\u7F8E\u56E2\u6392\u961F\u4EA7\u54C1'
            ),
            '/\u670D\u52A1\uFF08\u4EE5\u4E0B\u6216\u79F0\u201C\u6211\u4EEC\u7684\u4EA7\u54C1/\u670D\u52A1\u201D\uFF09\u662F\u6307\u7F8E\u56E2\u6392\u961F\u7684'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 10.5pt;' },
            '\u7F51\u7EDC\u53CA\u6280\u672F\u670D\u52A1\u63D0\u4F9B\u8005\u4E92\u8BDA\u4FE1\u606F\u6280\u672F\uFF08\u4E0A\u6D77\uFF09\u6709\u9650\u516C\u53F8'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'font',
              { face: '\u5B8B\u4F53' },
              '\u901A\u8FC7\u4E0B\u8FF0\u9014\u5F84\u5411\u60A8\u63D0\u4F9B\u7684\u4EA7\u54C1'
            ),
            '/\u670D\u52A1\uFF1A\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u7F8E\u56E2\u6392\u961FApp\u3001\u7F8E\u56E2\u5F00\u5E97\u5B9DApp\u3001\u5BA2\u6237\u7AEF\u4EE5\u53CA\u76F8\u5173\u5FAE\u4FE1\u5F00\u653E\u5E73\u53F0\u8D26\u53F7\u6216\u5C0F\u7A0B\u5E8F\u7B49\u3002'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\u672C\u653F\u7B56\u6240\u79F0\u7684\u7F8E\u56E2\u6392\u961F\u53CA\u5176\u5173\u8054\u65B9\u662F\u6307'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 10.5pt;' },
            '\u4E92\u8BDA\u4FE1\u606F\u6280\u672F\uFF08\u4E0A\u6D77\uFF09\u6709\u9650\u516C\u53F8'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'font',
              { face: '\u5B8B\u4F53' },
              '\u53CA\u73B0\u6709\u548C'
            ),
            '/\u6216\u672A\u6765\u8BBE\u7ACB\u7684\u76F8\u5173\u5173\u8054\u516C\u53F8\u7684\u5355\u79F0\u6216\u5408\u79F0\u3002'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 0pt 0pt 0.0001pt; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 12pt;' },
            '\xA0'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
              '\u8BF7\u60A8\u6CE8\u610F'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\uFF0C'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
              __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
                'font',
                { face: '\u5B8B\u4F53' },
                '\u60A8\u5E94\u4FDD\u8BC1\u5728\u4F7F\u7528\u6211\u4EEC\u7684\u4EA7\u54C1'
              ),
              '/\u670D\u52A1\u6240\u63D0\u4F9B\u7684\u4E00\u5207\u6570\u636E\u4FE1\u606F\u5747\u4E3A\u771F\u5B9E\uFF0C\u4E14\u7ECF\u8FC7\u5408\u6CD5\u9014\u5F84\u83B7\u5F97\uFF0C \u5982\u5176\u4E2D\u5305\u542B\u7B2C\u4E09\u65B9\u4E2A\u4EBA\u4FE1\u606F\uFF08\u5982\u60A8\u7684\u5458\u5DE5\u4FE1\u606F\u3001\u4F7F\u7528\u7F8E\u56E2\u6392\u961F\u670D\u52A1\u7528\u6237\u6216\u4F1A\u5458\u7684\u624B\u673A\u53F7\u3001\u4F9B\u5E94\u5546\u4FE1\u606F\u4EE5\u53CA\u60A8\u540E\u7EED\u4F7F\u7528\u65B0\u589E\u529F\u80FD\u65F6\u6240\u63D0\u4F9B\u7684\u5176\u4ED6\u4E2A\u4EBA\u4FE1\u606F\uFF09\uFF0C \u8BF7\u786E\u8BA4\u60A8\u5DF2\u53D6\u5F97\u8BE5\u4FE1\u606F\u6240\u6709\u65B9\u7684\u5145\u5206\u3001\u5408\u6CD5\u7684\u6388\u6743\uFF0C\u4E00\u65E6\u60A8\u5728\u4F7F\u7528\u6211\u4EEC\u670D\u52A1\u7684\u8FC7\u7A0B\u4E2D\u63D0\u4F9B\u6B64\u7C7B\u4FE1\u606F\uFF0C \u6211\u4EEC\u5C06\u8BA4\u4E3A\u8BE5\u7C7B\u4FE1\u606F\u5747\u4E3A\u60A8\u6709\u6743\u5904\u7406\uFF0C\u4E0D\u5B58\u5728\u4EFB\u4F55\u8FDD\u53CD\u6CD5\u5F8B\u3001\u6CD5\u89C4\u6216\u4FB5\u72AF\u4EFB\u4F55\u7B2C\u4E09\u65B9\u5408\u6CD5\u6743\u5229\u7684\u4E8B\u7531/\u7455\u75B5/\u573A\u666F\u3002 \u672C\u653F\u7B56\u4E0D\u9002\u7528\u4E8E\u60A8\u901A\u8FC7\u6211\u4EEC\u7684\u4EA7\u54C1/\u670D\u52A1\u800C\u63A5\u5165\u7684\u5176\u4ED6\u7B2C\u4E09\u65B9\u4EA7\u54C1/\u670D\u52A1(\u201C\u5176\u4ED6\u7B2C\u4E09\u65B9\u201D\uFF0C\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\u60A8\u7684\u4EA4\u6613\u76F8\u5BF9\u65B9\u3001\u4EFB\u4F55\u7B2C\u4E09\u65B9\u7F51\u7AD9\u4EE5\u53CA\u7B2C\u4E09\u65B9\u670D\u52A1\u63D0\u4F9B\u8005)\uFF0C \u5177\u4F53\u89C4\u5B9A\u8BF7\u53C2\u7167\u8BE5\u7B2C\u4E09\u65B9\u7684\u9690\u79C1\u653F\u7B56\u6216\u7C7B\u4F3C\u58F0\u660E\u3002'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 0pt 0pt 0.0001pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-family: \u5FAE\u8F6F\u96C5\u9ED1; font-size: 13.5pt;' },
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement('br', null)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
              '\u4E00\u3001\u6211\u4EEC\u5982\u4F55\u6536\u96C6\u548C\u4F7F\u7528\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\u6211\u4EEC\u4F1A\u51FA\u4E8E\u672C\u653F\u7B56\u6240\u8FF0\u7684\u4EE5\u4E0B\u76EE\u7684\uFF0C\u6536\u96C6\u548C\u4F7F\u7528\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u8BF7\u6CE8\u610F\uFF0C\u65E0\u6CD5\u4E0E\u4EFB\u4F55\u7279\u5B9A\u4E2A\u4EBA\u76F4\u63A5\u5EFA\u7ACB\u8054\u7CFB\u7684\u6570\u636E\uFF0C\u4E0D\u5C5E\u4E8E\u4E2A\u4EBA\u4FE1\u606F\u3002'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\uFF08\u4E00\uFF09\u60A8\u5411\u6211\u4EEC\u63D0\u4F9B\u7684\u4FE1\u606F'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '1'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\u3001\u5E2E\u52A9\u60A8\u767B\u5F55\u6211\u4EEC\u7684\u5546\u6237\u7BA1\u7406\u540E\u53F0'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'font',
              { face: '\u5B8B\u4F53' },
              '\u4E3A\u767B\u5F55\u6211\u4EEC\u7684\u5546\u6237\u7BA1\u7406\u540E\u53F0\uFF08\u7F8E\u56E2\u6392\u961F'
            ),
            'APP\uFF09\uFF0C'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 10.5pt;' },
            '\u4EE5\u4FBF\u6211\u4EEC\u4E3A\u60A8\u63D0\u4F9B\u5BF9\u5E94\u7684\u670D\u52A1\uFF0C\u60A8\u9700\u8981\u63D0\u4F9B'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'font-size: 10.5pt;' },
              '\u624B\u673A\u53F7\u7801\u3001\u7F51\u7EDC\u8EAB\u4EFD\u8BC6\u522B\u4FE1\u606F\uFF08\u5982\u8D26\u53F7\u3001\u5BC6\u7801\u7B49\uFF09'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 10.5pt;' },
            '\u7B49\uFF0C\u6216\u8005'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\u60A8\u4E5F\u53EF\u4EE5\u76F4\u63A5\u4F7F\u7528\u6211\u4EEC\u5173\u8054\u8D26\u53F7\uFF08\u5982\u7F8E\u56E2\u5F00\u5E97\u5B9D\u3001\u7F8E\u56E2\u6536\u94F6\u667A\u80FD\u7248\uFF09\u767B\u5F55\u6211\u4EEC\u5546\u6237\u7BA1\u7406\u7248\u540E\u53F0\uFF0C\u6B64\u65F6\uFF0C\u60A8\u9700\u8981\u63D0\u4F9B'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
              '\u5173\u8054\u8D26\u53F7\u4FE1\u606F\uFF08\u5173\u8054\u8D26\u53F7\u7684\u8D26\u53F7\u3001\u5BC6\u7801\u7B49\uFF09'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\u4EE5\u4FBF\u60A8\u80FD\u591F\u6B63\u5E38\u767B\u5F55\u3002'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 0pt 0pt 0.0001pt; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 12pt;' },
            '\xA0'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 10.5pt;' },
            '2\u3001\u66F4\u597D\u7684\u4E3A\u60A8\u63D0\u4F9B\u670D\u52A1'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 10.5pt;' },
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'font',
              { face: '\u5B8B\u4F53' },
              '\u4E3A\u4FBF\u4E8E\u5411\u60A8\u63D0\u4F9B\u4EA7\u54C1'
            ),
            '/\u670D\u52A1\uFF0C\u6211\u4EEC\u6709\u6743\u4ECE\u8EAB\u4EFD\u6821\u9A8C\u3001\u5B8C\u6210\u4EA4\u6613\u3001\u552E\u540E\u53CA\u7528\u6237\u670D\u52A1\u3001\u63D0\u4F9B\u5B89\u5168\u4FDD\u969C\u7B49\u591A\u79CD\u89D2\u5EA6\uFF0C\u6536\u96C6\u60A8\u5411\u6211\u4EEC\u63D0\u4F9B\u7684'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'font-size: 10.5pt;' },
              '\u8054\u7CFB\u4EBA\u4FE1\u606F\uFF08\u59D3\u540D\u3001\u6027\u522B\u3001\u7535\u8BDD\u53F7\u7801\u7B49\uFF09\u3001\u6CD5\u5B9A\u4EE3\u8868\u4EBA\u4FE1\u606F\uFF08\u59D3\u540D\u3001\u624B\u673A\u53F7\u3001\u8EAB\u4EFD\u8BC1\u53F7\u7B49\uFF09\u3001\u5B9E\u540D\u8EAB\u4EFD\u4FE1\u606F \uFF08\u5982\u8EAB\u4EFD\u8BC1\u7B49\u8F7D\u660E\u60A8\u5B9E\u540D\u8EAB\u4EFD\u7684\u7167\u7247\u3001\u590D\u5370\u4EF6\u3001\u53F7\u7801\u3001\u60A8\u7684\u7167\u7247\u6216\u8005\u4EBA\u8138\u8BC6\u522B\u8FDB\u884C\u8BA4\u8BC1\u7B49\uFF09\u3001\u8054\u7CFB\u5730\u5740\u3001\u7535\u5B50\u90AE\u7BB1\u3001\u94F6\u884C\u8D26\u6237\u6216\u5176\u4ED6\u652F\u4ED8\u5DE5\u5177\u7684\u8D26\u6237\u4FE1\u606F'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'font-size: 10.5pt;' },
              '\u7B49\u3002'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement('b', null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'font-size: 10.5pt;' },
              '\u4E3A\u4FBF\u4E8E\u60A8\u5728\u4F7F\u7528\u670D\u52A1\u8FC7\u7A0B\u4E2D\u626B\u7801\u3001\u62CD\u7167\u3001\u4E0A\u4F20\u56FE\u7247\u7B49\uFF0C\u60A8\u53EF\u4EE5\u9009\u62E9\u5F00\u542F\u7CFB\u7EDF\u7684\u76F8\u518C\u6743\u9650\uFF0C\u901A\u8FC7\u4E3B\u52A8\u4E0A\u4F20\u56FE\u7247\u3001\u89C6\u9891\u7B49\u65B9\u5F0F\u6388\u6743\u6211\u4EEC\u8BBF\u95EE\u60A8\u7684\u76F8\u518C\u3002 \u6B64\u9879\u529F\u80FD\u60A8\u53EF\u4EE5\u5728\u7CFB\u7EDF\u6743\u9650\u4E2D\u5173\u95ED\uFF0C\u4E00\u65E6\u5173\u95ED\u60A8\u5C06\u53EF\u80FD\u65E0\u6CD5\u901A\u8FC7\u4E0A\u4F20\u56FE\u7247\u3001\u89C6\u9891\u7B49\u65B9\u5F0F\u8FDB\u884C\u66F4\u6362\u5934\u50CF\u3001\u53D1\u5E03\u5E26\u56FE\u70B9\u8BC4\u7B49\uFF0C\u4F46\u4E0D\u4F1A\u5F71\u54CD\u60A8\u4EAB\u53D7\u7F8E\u56E2\u6392\u961F\u670D\u52A1\u7684\u57FA\u672C\u529F\u80FD\u3002'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement('b', null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'font-size: 10.5pt;' },
              '\u4E3A\u4FBF\u4E8E\u60A8\u5728\u4F7F\u7528\u670D\u52A1\u8FC7\u7A0B\u4E2D\u66F4\u597D\u5730\u8FDE\u63A5\u84DD\u7259\u670D\u52A1\uFF0C\u901A\u8FC7\u6240\u63D0\u4F9B\u7684\u4F4D\u7F6E\u4FE1\u606F\u66F4\u51C6\u786E\u4F7F\u67D0\u4E9B\u8FDE\u63A5\u4EFB\u52A1\uFF08\u4F8B\u5982\u901A\u8FC7\u84DD\u7259\u4F4E\u529F\u8017'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'font-size: 10.5pt;' },
              '\xA0(BLE) \u8FDE\u63A5\u5230\u9644\u8FD1\u7684\u8BBE\u5907\uFF09'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'font-size: 10.5pt;' },
              '\u80FD\u66F4\u597D\u5730\u63D0\u4F9B\u60A8\u4FBF\u5229\u3002\u4F8B\u5982\u8FDE\u63A5\u9644\u8FD1\u6253\u5370\u673A\u3001\u84DD\u7259\u97F3\u7BB1\u7B49\u5176\u4ED6\u8BBE\u5907\u3002\u6B64\u9879\u529F\u80FD\u60A8\u53EF\u4EE5\u5728\u7CFB\u7EDF\u6743\u9650\u4E2D\u5173\u95ED\uFF0C \u4E00\u65E6\u5173\u95ED\u60A8\u5C06\u53EF\u80FD\u65E0\u6CD5\u901A\u8FC7\u4E0A\u4F20\u56FE\u7247\u3001\u89C6\u9891\u7B49\u65B9\u5F0F\u8FDB\u884C\u66F4\u6362\u5934\u50CF\u3001\u53D1\u5E03\u5E26\u56FE\u70B9\u8BC4\u7B49\uFF0C\u4F46\u4E0D\u4F1A\u5F71\u54CD\u60A8\u4EAB\u53D7\u7F8E\u56E2\u6392\u961F\u670D\u52A1\u7684\u57FA\u672C\u529F\u80FD\u3002'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement('b', null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'font-size: 10.5pt;' },
              '\u60A8\u5728\u4F7F\u7528\u670D\u52A1\u7684\u8FC7\u7A0B\u4E2D\u6240\u63D0\u4EA4\u7684\u4EFB\u4F55\u6587\u5B57\u3001\u7167\u7247\u3001\u89C6\u9891\u7B49\u5404\u79CD\u5F62\u5F0F\u7684\u4FE1\u606F\uFF0C\u4E5F\u53EF\u80FD\u4F1A\u5305\u542B\u6216\u8005\u5173\u8054\u5230\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 10.5pt;' },
            '\uFF0C\u6211\u4EEC\u5C06\u5BF9\u4E8E\u4E0A\u8FF0\u4FE1\u606F\u4E2D\u6D89\u53CA\u7684\u4E2A\u4EBA\u4FE1\u606F\u4E88\u4EE5\u4E25\u683C\u4FDD\u62A4\u3002'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement('b', null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'font-size: 10.5pt;' },
              __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
                'font',
                { face: '\u5B8B\u4F53' },
                '\u5728\u5B9E\u540D\u8BA4\u8BC1\u7684\u573A\u666F\u4E0B\uFF0C\u7F8E\u56E2\u6392\u961F'
              ),
              'APP\u5C06\u5411\u5408\u4F5C\u7684\u7B2C\u4E09\u65B9\u63D0\u4EA4\u60A8\u7684\u524D\u8FF0\u4FE1\u606F\uFF0C\u5E76\u4ECE\u5408\u6CD5\u4FDD\u5B58\u6709\u60A8\u4E2A\u4EBA\u4FE1\u606F\u7684\u7B2C\u4E09\u65B9\u5904\u83B7\u5F97\u3001\u4FDD\u5B58\u6709\u5173\u60A8\u8EAB\u4EFD\u4FE1\u606F\u7684\u9A8C\u8BC1\u7ED3\u679C\u3002'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement('b', null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 10.5pt;' },
            '3'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 10.5pt;' },
            '\u3001\u6211\u4EEC\u5728\u60A8\u4F7F\u7528\u670D\u52A1\u8FC7\u7A0B\u4E2D\u6536\u96C6\u7684\u4FE1\u606F'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 10.5pt;' },
            '\u4E3A\u5411\u60A8\u5C55\u793A\u6709\u5173\u6392\u961F\u8BA2\u5355\u4FE1\u606F\uFF0C\u6211\u4EEC\u4F1A\u6536\u96C6\u60A8\u5728\u4F7F\u7528\u6211\u4EEC\u670D\u52A1\u8FC7\u7A0B\u4E2D\u4EA7\u751F\u7684'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'font-size: 10.5pt;' },
              '\u6392\u961F\u8BA2\u5355\u4FE1\u606F\uFF08\u5982\u6392\u961F\u987E\u5BA2\u9884\u7559\u8054\u7CFB\u65B9\u5F0F\u3001\u5C31\u9910\u4EBA\u6570\u3001\u5C31\u9910\u610F\u5411\u7B49\uFF09'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 10.5pt;' },
            '\u7528\u4E8E\u5411\u60A8\u5C55\u793A\u53CA\u4FBF\u4E8E\u60A8\u5BF9\u60A8\u95E8\u5E97\u7684\u6392\u961F\u60C5\u51B5\u8FDB\u884C\u7BA1\u7406\u3002'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 10.5pt;' },
            '\u4E3A\u4E86\u6EE1\u8DB3\u6CD5\u5F8B\u6CD5\u89C4\u53CA\u63D0\u4F9B\u670D\u52A1\u7684\u57FA\u672C\u8981\u6C42\uFF0C\u4FDD\u969C\u60A8\u7684\u8D26\u53F7\u5B89\u5168\u4E0E\u7CFB\u7EDF\u8FD0\u884C\u5B89\u5168\u4EE5\u53CA\u66F4\u597D\u7684\u4F7F\u7528\u6211\u4EEC\u7684\u4EA7\u54C1\uFF0C\u63D0\u5347\u4EA7\u54C1\u95EE\u9898\u6392\u67E5\u6548\u7387\uFF0C\u6211\u4EEC\u4F1A\u6536\u96C6\u60A8\u7684'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'font-size: 10.5pt;' },
              '\u65E5\u5FD7\u4FE1\u606F\u3001\u8BA2\u5355\u4FE1\u606F\u3001\u6D4F\u89C8\u53CA\u641C\u7D22\u4FE1\u606F\u3001\u4F4D\u7F6E\u4FE1\u606F\u3001\u8BBE\u5907\u4FE1\u606F\u3001\u884C\u4E3A\u504F\u597D\uFF0C\u95EE\u9898\u4E0A\u62A5\u63CF\u8FF0\uFF0C \u8054\u7CFB\u7535\u8BDD\u4EE5\u53CA\u60A8\u5728\u4F7F\u7528\u670D\u52A1\u8FC7\u7A0B\u4E2D\u6240\u63D0\u4EA4\u7684\u4EFB\u4F55\u6587\u5B57\u3001\u7167\u7247\u3001\u89C6\u9891\u4FE1\u606F\u7B49\u5E76\u5C06\u60A8\u5728\u4F7F\u7528\u6211\u4EEC\u5173\u8054\u65B9\u7684\u67D0\u9879\u670D\u52A1\u4E2D\u63D0\u4F9B\u7684\u4FE1\u606F\u7ED3\u5408\u8D77\u6765\uFF0C\u8FDB\u884C\u7EFC\u5408\u7EDF\u8BA1\u3001\u5206\u6790\u4EE5\u5F62\u6210\u7528\u6237\u753B\u50CF'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 10.5pt;' },
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'font',
              { face: '\u5B8B\u4F53' },
              '\uFF0C\u7528\u6765\u5411\u60A8\u63A8\u8350\u6216\u5C55\u793A\u60A8\u53EF\u80FD\u611F\u5174\u8DA3\u7684\u4EA7\u54C1'
            ),
            '/\u670D\u52A1\u4FE1\u606F\u3002'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 10.5pt;' },
            '4'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 10.5pt;' },
            '\u3001\u5F53\u60A8\u4E0E\u6211\u4EEC\u8054\u7CFB\u65F6\uFF0C\u6211\u4EEC'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'font-size: 10.5pt;' },
              __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
                'font',
                { face: '\u5B8B\u4F53' },
                '\u53EF\u80FD\u4F1A\u6536\u96C6\u60A8\u7684\u901A\u4FE1'
              ),
              '/\u901A\u8BDD\u8BB0\u5F55\u548C\u5185\u5BB9\u6216\u60A8\u7559\u4E0B\u7684\u8054\u7CFB\u65B9\u5F0F'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 10.5pt;' },
            '\uFF0C\u4EE5\u4FBF\u4E0E\u60A8\u8054\u7CFB\u3001\u5E2E\u52A9\u60A8\u89E3\u51B3\u95EE\u9898\uFF0C\u6216\u8BB0\u5F55\u76F8\u5173\u95EE\u9898\u7684\u5904\u7406\u65B9\u6848\u53CA\u7ED3\u679C\u3002'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '5'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\u3001\u5F53\u60A8\u53C2\u4E0E\u6211\u4EEC\u7684\u63A8\u5E7F\u6D3B\u52A8\u548C\u95EE\u5377\u8C03\u67E5\u8FC7\u7A0B\u4E2D\uFF0C\u6211\u4EEC\u53EF\u80FD\u4F1A\u6536\u96C6\u60A8\u4E3B\u52A8\u63D0\u4F9B\u7684\u76F8\u5173\u4FE1\u606F\u3002'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\uFF08\u4E8C\uFF09\u6211\u4EEC\u53EF\u80FD\u95F4\u63A5\u6536\u96C6\u5230\u7684\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\u4E3A\u80FD\u5411\u60A8\u63D0\u4F9B\u66F4\u4F18\u8D28\u7684\u670D\u52A1\uFF0C\u540C\u65F6\u4E3A\u80FD\u786E\u8BA4\u4EA4\u6613\u72B6\u6001\u53CA\u4E3A\u60A8\u63D0\u4F9B\u552E\u540E\u4E0E\u4E89\u8BAE\u89E3\u51B3\u670D\u52A1\uFF0C'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
              '\u60A8\u6388\u6743\u6211\u4EEC\u901A\u8FC7\u60A8\u9009\u62E9\u7684\u4EA4\u6613\u5BF9\u8C61\u548C\u4EA4\u6613\u76F4\u63A5\u6D89\u53CA\u7684\u7B2C\u4E09\u65B9\u4FE1\u606F\u7CFB\u7EDF\u3001\u652F\u4ED8\u673A\u6784\u7B49\u6536\u96C6\u4E0E\u4EA4\u6613\u8FDB\u5EA6\u76F8\u5173\u7684\u60A8\u7684\u4EA4\u6613\u3001\u652F\u4ED8\u3001\u670D\u52A1\u7B49\u4FE1\u606F\uFF0C \u6216\u8005\u5C06\u60A8\u7684\u4FE1\u606F\u5171\u4EAB\u7ED9\u4E0A\u8FF0\u670D\u52A1\u63D0\u4F9B\u8005\uFF0C\u4EE5\u4FBF\u4E8E\u6211\u4EEC\u5904\u7406\u60A8\u7684\u8BA2\u5355\u5E76\u4FDD\u8BC1\u670D\u52A1\u7684\u987A\u5229\u5B8C\u6210\uFF0C\u6216\u8005\u66F4\u597D\u5730\u9884\u9632\u8BC8\u9A97\u3001\u5237\u5355\u7B49\u6076\u610F\u884C\u4E3A'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'font',
              { face: '\u5B8B\u4F53' },
              '\u3002\u6211\u4EEC\u4F1A\u4F9D\u636E\u6CD5\u5F8B\u6CD5\u89C4\u7684\u8981\u6C42\u4EE5\u53CA\u4E0E\u7B2C\u4E09\u65B9\u7684\u7EA6\u5B9A\uFF0C\u5728\u60A8\u6388\u6743\u8303\u56F4\u5185\u5411\u7F8E\u56E2\u6392\u961F'
            ),
            'APP\u7684\u5173\u8054\u65B9\u3001\u5408\u4F5C\u4F19\u4F34\u7B49\u83B7\u5F97\u60A8\u7684\u6709\u5173\u4FE1\u606F\uFF0C\u5E76\u5BF9\u5176\u4FE1\u606F\u6765\u6E90\u7684\u5408\u6CD5\u6027\u8FDB\u884C\u786E\u8BA4\u540E\u4F7F\u7528\u60A8\u7684\u8FD9\u4E9B\u4FE1\u606F\u3002'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 0pt 0pt 0.0001pt; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 12pt;' },
            '\xA0'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'font',
              { face: '\u5B8B\u4F53' },
              '\uFF08\u4E09\uFF09\u6539\u8FDB\u6211\u4EEC\u7684\u4EA7\u54C1'
            ),
            '/\u670D\u52A1'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 10.5pt;' },
            '\u4E3A\u6539\u5584\u6211\u4EEC\u7684\u4EA7\u54C1\u6216\u670D\u52A1\u3001\u5411\u60A8\u63D0\u4F9B\u4E2A\u6027\u5316\u7684\u4FE1\u606F\u641C\u7D22\u53CA\u4EA4\u6613\u670D\u52A1\uFF0C\u4F7F\u60A8\u53CA\u65F6\u4E86\u89E3\u4E30\u5BCC\u7684\u5546\u54C1\u4FE1\u606F\uFF0C\u63D0\u5347\u670D\u52A1\u4F53\u9A8C\uFF0C'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'font-size: 10.5pt;' },
              '\u6211\u4EEC\u4F1A\u6839\u636E\u60A8\u7684\u6D4F\u89C8\u53CA\u641C\u7D22\u8BB0\u5F55\u3001\u8BBE\u5907\u4FE1\u606F\u3001\u4F4D\u7F6E\u4FE1\u606F\u3001\u8BA2\u5355\u4FE1\u606F\uFF0C\u63D0\u53D6\u60A8\u7684\u6D4F\u89C8\u3001\u641C\u7D22\u504F\u597D\u3001\u884C\u4E3A\u4E60\u60EF\u3001\u4F4D\u7F6E\u4FE1\u606F\u7B49\u7279\u5F81\uFF0C \u57FA\u4E8E\u7279\u5F81\u6807\u7B7E\u8FDB\u884C\u95F4\u63A5\u4EBA\u7FA4\u753B\u50CF\u5E76\u5C55\u793A\u3001\u63A8\u9001\u76F8\u5173\u4FE1\u606F\uFF0C\u5305\u62EC\u901A\u8FC7\u77ED\u4FE1\u3001\u7535\u8BDD\u3001\u90AE\u4EF6\u3001\u7EBF\u4E0A\u5C55\u793A\u5404\u79CD\u65B9\u5F0F\u5411\u4F60\u63A8\u9001\u8425\u9500\u6D3B\u52A8\u4FE1\u606F\u3001\u5546\u54C1\u4EA4\u6613\u4FE1\u606F\u3001\u4FC3\u9500\u4FE1\u606F\u3001\u8C03\u7814\u95EE\u5377\u3002 \u5982\u679C\u60A8\u4E0D\u540C\u610F\u63A5\u6536\u6765\u81EA\u6211\u4EEC\u7684\u63A8\u9001\u4FE1\u606F\uFF0C\u53EF\u4EE5\u901A\u8FC7\u76F8\u5E94\u7684\u9000\u8BA2\u65B9\u5F0F\u8FDB\u884C\u9000\u8BA2\uFF0C\u6216\u8005\u901A\u8FC7\u62E8\u6253\u5546\u670D\u7535\u8BDD\u660E\u786E\u8868\u793A\u62D2\u7EDD'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 10.5pt;' },
            '\u3002'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 0pt 0pt 0.0001pt; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 12pt;' },
            '\xA0'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\uFF08\u56DB\uFF09\u8BBE\u5907\u6743\u9650\u8C03\u7528'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\u4E3A\u786E\u4FDD\u76F8\u5173\u4E1A\u52A1\u529F\u80FD\u7684\u6B63\u5E38\u5B9E\u73B0\uFF0C\u6211\u4EEC\u9700\u8981\u6839\u636E\u5177\u4F53\u7684\u4F7F\u7528\u573A\u666F\u8C03\u7528\u5BF9\u5E94\u7684\u5FC5\u8981\u6743\u9650\uFF0C\u5E76\u5728\u8C03\u7528\u524D\u5411\u60A8\u5F39\u7A97\u8BE2\u95EE\uFF0C\u5177\u4F53\u7684\u6743\u9650\u8C03\u7528\u8BF4\u660E\u8BE6\u89C1\u94FE\u63A5\uFF1A'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            {
              style: 'color: rgb(0, 0, 255); text-decoration: underline; font-size: 10.5pt;',
              onClick: this.jumpToAuthcall
            },
            'Android \u7CFB\u7EDF\u6743\u9650\u8C03\u7528\u8BF4\u660E'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            null,
            '\u60A8\u53EF\u4EE5\u5728\u8BBE\u5907\u7684\u8BBE\u7F6E\u4E2D\u9009\u62E9\u5173\u95ED\u90E8\u5206\u6216\u8005\u5168\u90E8\u6743\u9650\uFF0C\u8FD9\u53EF\u80FD\u5BFC\u81F4\u5BF9\u5E94\u7684\u4E1A\u52A1\u529F\u80FD\u65E0\u6CD5\u5B9E\u73B0\u6216\u8005\u65E0\u6CD5\u8FBE\u5230\u9884\u671F\u6548\u679C\u3002'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\uFF08\u4E94\uFF09\u4E3A\u60A8\u63D0\u4F9B\u5B89\u5168\u4FDD\u969C'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 0pt 0pt 0.0001pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'font',
              { face: '\u5B8B\u4F53' },
              '\u4E3A\u60A8\u63D0\u4F9B\u5B89\u5168\u4FDD\u969C\u4E3A\u4E86\u4FDD\u969C\u60A8\u7684\u8D26\u53F7\u5B89\u5168\u3001\u4EA4\u6613\u5B89\u5168\u4EE5\u53CA\u7CFB\u7EDF\u8FD0\u884C\u5B89\u5168\uFF0C\u6EE1\u8DB3\u6CD5\u5F8B\u6CD5\u89C4\u548C\u6211\u4EEC\u534F\u8BAE\u89C4\u5219\u7684\u76F8\u5173\u8981\u6C42\uFF0C\u5728\u60A8\u8BBF\u95EE\u53CA\u4F7F\u7528\u6211\u4EEC\u7684\u4EA7\u54C1/\u670D\u52A1\u8FC7\u7A0B\u4E2D\uFF0C\u7ECF\u60A8\u6388\u6743\u6211\u4EEC\u4F1A\u83B7\u53D6\u60A8\u7684\u8BBE\u5907\u4FE1\u606F\u3001\u7F51\u7EDC\u72B6\u6001\u4FE1\u606F\uFF0C\u5305\u62EC\u60A8\u4F7F\u7528\u7684\u8BBE\u5907\u578B\u53F7\u3001\u786C\u4EF6\u5E8F\u5217\u53F7\u3001\u8BBE\u5907MAC\u5730\u5740\u3001\u552F\u4E00\u8BBE\u5907\u8BC6\u522B\u7801\uFF08\u5982IMEI/MEID/IMSI/AndroidID/IDFA/IDFV/OAID\u3001SIM\u5361IMSI\u3001ICCID\u4FE1\u606F\u7B49\u8BBE\u5907\u6807\u8BC6\u7B26\uFF09\u3001\u8FD0\u884C\u4E2D\u8FDB\u7A0B\u4FE1\u606F\u3001\u79FB\u52A8\u5E94\u7528\u5217\u8868\u3001',
              __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
                'a',
                { href: 'https://fe-config.meituan.com/bm/config/eia59b6h023i964hc4.html' },
                '\u4F20\u611F\u5668\u4FE1\u606F\uFF08\u70B9\u51FB\u67E5\u770B\uFF09'
              ),
              '\u3001WIFI\u72B6\u6001\u3001\u7535\u4FE1\u8FD0\u8425\u5546\u7B49\u8F6F\u786C\u4EF6\u7279\u5F81\u4FE1\u606F\u3002\u672A\u7ECF\u60A8\u7684\u6388\u6743\uFF0C\u6211\u4EEC\u4E0D\u4F1A\u63D0\u524D\u83B7\u53D6\u4EE5\u4E0A\u4FE1\u606F\u3002'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 0pt 0pt 0.0001pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'font',
              { face: '\u5B8B\u4F53' },
              '\u4E3A\u63D0\u9AD8\u60A8\u4F7F\u7528\u6211\u4EEC\u63D0\u4F9B\u7684\u670D\u52A1\u7684\u5B89\u5168\u6027\uFF0C\u66F4\u51C6\u786E\u5730\u9884\u9632\u9493\u9C7C\u7F51\u7AD9\u6B3A\u8BC8\u548C\u6728\u9A6C\u75C5\u6BD2\uFF0C \u6211\u4EEC\u53EF\u80FD\u4F1A\u4F7F\u7528\u6216\u6574\u5408\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u4EE5\u53CA\u6211\u4EEC\u7684\u5173\u8054\u65B9\u3001\u5408\u4F5C\u4F19\u4F34\u53D6\u5F97\u60A8\u6388\u6743\u6216\u8005\u4F9D\u6CD5\u5171\u4EAB\u7684\u4FE1\u606F\uFF0C \u6839\u636E\u60A8\u7684\u4F7F\u7528\u4E60\u60EF\u548C\u5E38\u7528\u8F6F\u4EF6\u4FE1\u606F\u6765\u7EFC\u5408\u5224\u65AD\u60A8\u7684\u8D26\u53F7\u53CA\u4EA4\u6613\u98CE\u9669\uFF0C\u5305\u62EC\u9A8C\u8BC1\u8EAB\u4EFD\uFF0C \u9884\u9632\u3001\u53D1\u73B0\u3001\u8C03\u67E5\u53EF\u80FD\u5B58\u5728\u7684\u6B3A\u8BC8\u3001\u7F51\u7EDC\u75C5\u6BD2\u3001\u7F51\u7EDC\u653B\u51FB\u7684\u5B89\u5168\u98CE\u9669\u4EE5\u53CA\u8FDD\u53CD\u6211\u4EEC\u6216\u5173\u8054\u65B9\u534F\u8BAE\u3001\u653F\u7B56\u6216\u89C4\u5219\u7684\u884C\u4E3A\uFF0C \u4EE5\u4FDD\u62A4\u60A8\u3001\u5176\u4ED6\u7528\u6237\u3001\u6211\u4EEC\u6216\u5173\u8054\u65B9\u7684\u5408\u6CD5\u6743\u76CA\uFF0C\u5E76\u8BB0\u5F55\u4E00\u4E9B\u6211\u4EEC\u8BA4\u4E3A\u6709\u98CE\u9669\u7684\u94FE\u63A5'
            ),
            '(\u201CURL\u201D)\u3002'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 0pt 0pt 0.0001pt; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 12pt;' },
            '\xA0'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\uFF08\u516D\uFF09\u5F81\u5F97\u540C\u610F\u7684\u4F8B\u5916'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\u8BF7\u60A8\u77E5\u6089\uFF0C\u4EE5\u4E0B\u60C5\u5F62\u4E2D\uFF0C\u6211\u4EEC\u6536\u96C6\u3001\u4F7F\u7528\u4E2A\u4EBA\u4FE1\u606F'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
              '\u65E0\u9700'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\u5F81\u5F97\u60A8\u7684\u6388\u6743\u540C\u610F\uFF1A'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '1\u3001\u4E0E\u56FD\u5BB6\u5B89\u5168\u3001\u56FD\u9632\u5B89\u5168\u6709\u5173\u7684\uFF1B'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '2\u3001\u4E0E\u516C\u5171\u5B89\u5168\u3001\u516C\u5171\u536B\u751F\u3001\u91CD\u5927\u516C\u5171\u5229\u76CA\u6709\u5173\u7684\uFF1B'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '3\u3001\u4E0E\u72AF\u7F6A\u4FA6\u67E5\u3001\u8D77\u8BC9\u3001\u5BA1\u5224\u548C\u5224\u51B3\u6267\u884C\u7B49\u6709\u5173\u7684\uFF1B'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '4\u3001\u51FA\u4E8E\u7EF4\u62A4\u4E2A\u4EBA\u4FE1\u606F\u4E3B\u4F53\u6216\u5176\u4ED6\u4E2A\u4EBA\u7684\u751F\u547D\u3001\u8D22\u4EA7\u7B49\u91CD\u5927\u5408\u6CD5\u6743\u76CA\u4F46\u53C8\u5F88\u96BE\u5F97\u5230\u672C\u4EBA\u540C\u610F\u7684\uFF1B'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '5\u3001\u6240\u6536\u96C6\u7684\u4E2A\u4EBA\u4FE1\u606F\u662F\u4E2A\u4EBA\u4FE1\u606F\u4E3B\u4F53\u81EA\u884C\u5411\u793E\u4F1A\u516C\u4F17\u516C\u5F00\u7684\uFF1B'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '6\u3001\u4ECE\u5408\u6CD5\u516C\u5F00\u62AB\u9732\u7684\u4FE1\u606F\u4E2D\u6536\u96C6\u7684\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u7684\uFF0C\u5982\u5408\u6CD5\u7684\u65B0\u95FB\u62A5\u9053\u3001\u653F\u5E9C\u4FE1\u606F\u516C\u5F00\u7B49\u6E20\u9053\uFF1B'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '7\u3001\u6839\u636E\u60A8\u7684\u8981\u6C42\u7B7E\u8BA2\u5408\u540C\u6240\u5FC5\u9700\u7684\uFF1B'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '8\u3001\u7528\u4E8E\u7EF4\u62A4\u6240\u63D0\u4F9B\u7684\u4EA7\u54C1\u4E0E/\u6216\u670D\u52A1\u7684\u5B89\u5168\u7A33\u5B9A\u8FD0\u884C\u6240\u5FC5\u9700\u7684\uFF0C\u4F8B\u5982\u53D1\u73B0\u3001\u5904\u7F6E\u4EA7\u54C1\u4E0E/\u6216\u670D\u52A1\u7684\u6545\u969C\uFF1B'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '9\u3001\u4E3A\u5408\u6CD5\u7684\u65B0\u95FB\u62A5\u9053\u6240\u5FC5\u9700\u7684\uFF1B'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '10\u3001\u5B66\u672F\u7814\u7A76\u673A\u6784\u57FA\u4E8E\u516C\u5171\u5229\u76CA\u5F00\u5C55\u7EDF\u8BA1\u6216\u5B66\u672F\u7814\u7A76\u6240\u5FC5\u8981\uFF0C\u4E14\u5BF9\u5916\u63D0\u4F9B\u5B66\u672F\u7814\u7A76\u6216\u63CF\u8FF0\u7684\u7ED3\u679C\u65F6\uFF0C\u5BF9\u7ED3\u679C\u4E2D\u6240\u5305\u542B\u7684\u4E2A\u4EBA\u4FE1\u606F\u8FDB\u884C\u53BB\u6807\u8BC6\u5316\u5904\u7406\u7684\uFF1B'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '11\u3001\u6CD5\u5F8B\u6CD5\u89C4\u89C4\u5B9A\u7684\u5176\u4ED6\u60C5\u5F62\u3002'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 0pt 0pt 0.0001pt; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 12pt;' },
            '\xA0'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
              __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
                'font',
                { face: '\u5B8B\u4F53' },
                '\u4E8C\u3001\u6211\u4EEC\u5982\u4F55\u4F7F\u7528'
              ),
              'Cookie\u548C\u540C\u7C7B\u6280\u672F'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
              '\uFF08\u4E00\uFF09'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
              'Cookie\u7684\u4F7F\u7528'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement('b', null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'font',
              { face: '\u5B8B\u4F53' },
              '\u4E3A\u786E\u4FDD\u7F51\u7AD9\u6B63\u5E38\u9AD8\u6548\u8FD0\u8F6C\u3001\u4E3A\u60A8\u83B7\u5F97\u66F4\u8F7B\u677E\u7684\u8BBF\u95EE\u4F53\u9A8C\u3001\u5411\u60A8\u63A8\u8350\u60A8\u53EF\u80FD\u611F\u5174\u8DA3\u7684\u5185\u5BB9\uFF0C\u6211\u4EEC\u4F1A\u5728\u60A8\u7684\u8BBE\u5907\u7EC8\u7AEF'
            ),
            '/\u7CFB\u7EDF\u4E0A\u5B58\u50A8\u540D\u4E3ACookie\u7684\u5C0F\u6570\u636E\u6587\u4EF6\u3002Cookie\u4F1A\u5E2E\u52A9\u60A8\u5728\u540E\u7EED\u8BBF\u95EE\u6211\u4EEC\u7F51\u7AD9\u65F6\u8C03\u7528\u60A8\u7684\u4FE1\u606F\uFF0C\u7B80\u5316\u60A8\u586B\u5199\u4E2A\u4EBA\u4FE1\u606F(\u4F8B\u5982\u4E00\u952E\u767B\u5F55\u7B49)\u7684\u6D41\u7A0B\uFF1B \u4E3A\u60A8\u63D0\u4F9B\u5B89\u5168\u8D2D\u7269\u7684\u504F\u597D\u8BBE\u7F6E\uFF1B\u5E2E\u52A9\u60A8\u4F18\u5316\u5BF9\u5E7F\u544A\u7684\u9009\u62E9\u4E0E\u4E92\u52A8;\u4FDD\u62A4\u60A8\u7684\u6570\u636E\u5B89\u5168\u7B49\u3002\u6211\u4EEC\u4E0D\u4F1A\u5C06Cookie\u7528\u4E8E\u672C\u9690\u79C1\u653F\u7B56\u6240\u8FF0\u76EE\u7684\u4E4B\u5916\u7684\u4EFB\u4F55\u7528\u9014\u3002 \u60A8\u53EF\u6839\u636E\u81EA\u5DF1\u7684\u504F\u597D\u7BA1\u7406\u6216\u5220\u9664Cookie\u3002\u60A8\u53EF\u4EE5\u6E05\u9664\u8BA1\u7B97\u673A\u6216\u79FB\u52A8\u8BBE\u5907\u4E0A\u4FDD\u5B58\u7684\u6240\u6709Cookie\uFF0C\u60A8\u6709\u6743\u63A5\u53D7\u6216\u62D2\u7EDDCookie\u3002 \u5927\u591A\u6570\u6D4F\u89C8\u5668\u4F1A\u81EA\u52A8\u63A5\u53D7Cookie\uFF0C\u4F46\u60A8\u901A\u5E38\u53EF\u6839\u636E\u81EA\u5DF1\u7684\u9700\u8981\u6765\u4FEE\u6539\u6D4F\u89C8\u5668\u7684\u8BBE\u7F6E\u4EE5\u62D2\u7EDDCookie\uFF1B \u53E6\u5916\uFF0C\u60A8\u4E5F\u53EF\u4EE5\u6E05\u9664\u8F6F\u4EF6\u5185\u4FDD\u5B58\u7684\u6240\u6709Cookie\u3002\u4F46\u60A8\u53EF\u80FD\u56E0\u6B64\u65E0\u6CD5\u5B8C\u5168\u4F53\u9A8C\u6211\u4EEC\u67D0\u4E9B\u4FBF\u6377\u6027\u548C\u5B89\u5168\u6027\u7684\u670D\u52A1\u529F\u80FD\u3002'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
              '\uFF08\u4E8C\uFF09\u7F51\u7EDC'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
              'Beacon\u548C\u540C\u7C7B\u6280\u672F\u7684\u4F7F\u7528'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement('b', null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\u9664'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            'Cookie\u5916\uFF0C\u6211\u4EEC\u7F51\u9875\u4E0A\u5E38\u4F1A\u5305\u542B\u4E00\u4E9B\u7535\u5B50\u56FE\u8C61 (\u79F0\u4E3A"\u5355\u50CF\u7D20"GIF\u6587\u4EF6\u6216"\u7F51\u7EDCBeacon")\u7B49\u5176\u4ED6\u540C\u7C7B\u6280\u672F\uFF0C \u5B83\u4EEC\u53EF\u4EE5\u5E2E\u52A9\u7F51\u7AD9\u8BA1\u7B97\u6D4F\u89C8\u7F51\u9875\u7684\u7528\u6237\u6216\u8BBF\u95EE\u67D0\u4E9BCookie\u3002\u6211\u4EEC\u4F7F\u7528\u7F51\u7EDCBeacon\u7684\u65B9\u5F0F\u6709:'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '1\u3001\u6211\u4EEC\u901A\u8FC7\u5728\u6211\u4EEC\u7F51\u7AD9\u4E0A\u4F7F\u7528\u7F51\u7EDCBeacon\uFF0C\u8BA1\u7B97\u7528\u6237\u8BBF\u95EE\u6570\u91CF\uFF0C\u5E76\u901A\u8FC7\u8BBF\u95EECookie\u8FA8\u8BA4\u6CE8\u518C\u7528\u6237\u3002'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '2\u3001\u6211\u4EEC\u901A\u8FC7\u5F97\u5230\u7684Cookie\u4FE1\u606F\uFF0C\u53EF\u4EE5\u5728\u6211\u4EEC\u7F51\u7AD9\u63D0\u4F9B\u4E2A\u6027\u5316\u670D\u52A1\u3002'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 0pt 0pt 0.0001pt; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 12pt;' },
            '\xA0'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\u4E09\u3001'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
              '\u6211\u4EEC\u5982\u4F55\u5171\u4EAB\u3001\u8F6C\u8BA9\u3001\u516C\u5F00\u62AB\u9732\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\uFF08\u4E00\uFF09\u5171\u4EAB'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\u6211\u4EEC\u4E0D\u4F1A\u4E0E\u7F8E\u56E2\u70B9\u8BC4\u4EE5\u5916\u7684\u4EFB\u4F55\u516C\u53F8\u3001\u7EC4\u7EC7\u548C\u4E2A\u4EBA\u5171\u4EAB\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4F46\u4EE5\u4E0B\u60C5\u51B5\u9664\u5916\uFF1A'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
              '\u57FA\u4E8E\u6CD5\u5B9A\u60C5\u5F62\u4E0B'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\uFF1A\u6839\u636E\u6CD5\u5F8B\u6CD5\u89C4\u7684\u89C4\u5B9A\u3001\u8BC9\u8BBC\u4E89\u8BAE\u89E3\u51B3\u9700\u8981\uFF0C\u6216\u884C\u653F\u3001\u53F8\u6CD5\u7B49\u6709\u6743\u673A\u5173\u4F9D\u6CD5\u63D0\u51FA\u7684\u8981\u6C42\uFF1B'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
              '\u4E0E\u5173\u8054\u516C\u53F8\u5171\u4EAB'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\uFF1A\u4E3A\u5411\u60A8\u63D0\u4F9B\u4E00\u81F4\u5316\u670D\u52A1\u4EE5\u53CA\u4FBF\u4E8E\u60A8\u8FDB\u884C\u7EDF\u4E00\u7BA1\u7406\uFF0C\u6211\u4EEC\u4F1A\u57FA\u4E8E\u5FC5\u8981\u6027\u7684\u524D\u63D0\u4E0B\u5C06\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u4E0E\u6211\u4EEC\u7684\u5173\u8054\u516C\u53F8\u5171\u4EAB\uFF1B'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
              '\u4E0E\u5408\u4F5C\u4F19\u4F34\u5206\u4EAB'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\uFF1A\u4EC5\u4E3A\u5B9E\u73B0\u672C\u653F\u7B56\u4E2D\u58F0\u660E\u7684\u76EE\u7684\uFF0C\u6211\u4EEC\u7684\u67D0\u4E9B\u670D\u52A1\u5C06\u7531\u4E1A\u52A1\u5408\u4F5C\u4F19\u4F34\u63D0\u4F9B\uFF0C\u6211\u4EEC\u53EF\u80FD\u4F1A\u5411\u4E1A\u52A1\u5408\u4F5C\u4F19\u4F34\u5171\u4EAB\u4E3A\u60A8\u63D0\u4F9B\u670D\u52A1\u6240\u5FC5\u8981\u7684'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
              '\u6392\u961F\u8BA2\u5355\u4FE1\u606F\u3001\u4F4D\u7F6E\u4FE1\u606F\u3001\u8D26\u6237\u4FE1\u606F\u3001\u652F\u4ED8\u4FE1\u606F'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\u7B49\uFF0C\u4EE5\u4FDD\u969C\u4E3A\u60A8\u63D0\u4F9B\u7684\u670D\u52A1\u987A\u5229\u5B8C\u6210\u3002'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
              '\u6211\u4EEC\u7684\u4E1A\u52A1\u5408\u4F5C\u4F19\u4F34\u5305\u62EC\u4F9B\u5E94\u5546\u3001\u7B2C\u4E09\u65B9\u670D\u52A1\u5408\u4F5C\u5546\u7B49\u4E1A\u52A1\u5408\u4F5C\u4F19\u4F34\uFF1B'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
              '\u57FA\u4E8E\u534F\u8BAE\u7EA6\u5B9A'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'font',
              { face: '\u5B8B\u4F53' },
              '\uFF1A\u4F9D\u636E\u60A8\u4E0E\u6211\u4EEC\u7B7E\u7F72\u7684\u76F8\u5173\u534F\u8BAE'
            ),
            '(\u5305\u62EC\u5728\u7EBF\u7B7E\u7F72\u7684\u7535\u5B50\u534F\u8BAE\u53CA\u7F8E\u56E2\u5E73\u53F0\u89C4\u5219)\u6216\u6CD5\u5F8B\u6587\u4EF6\uFF0C\u6709\u5FC5\u8981\u5411\u7B2C\u4E09\u65B9\u5171\u4EAB\u65F6\uFF1B'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
              '\u57FA\u4E8E\u5408\u7406\u5546\u4E1A\u4E60\u60EF'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\uFF1A\u4F8B\u5982\u4E0E\u7B2C\u4E09\u65B9\u5171\u4EAB\u8054\u5408\u8425\u9500\u6D3B\u52A8\u4E2D\u7684\u4E2D\u5956\u4FE1\u606F\uFF0C\u4EE5\u4FBF\u7B2C\u4E09\u65B9\u80FD\u53CA\u65F6\u5411\u60A8\u53D1\u653E\u5956\u54C1\uFF1B\u6216\u8005\u5728\u4E0E\u5176\u4ED6\u516C\u53F8\u8FDB\u884C\u8D44\u672C\u5E02\u573A\u6D3B\u52A8'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '(\u5305\u62EC\u4F46\u4E0D\u9650\u4E8EIPO\uFF0C\u503A\u5238\u53D1\u884C)\u63A5\u53D7\u5C3D\u804C\u8C03\u67E5\u65F6\uFF1B'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\u57FA\u4E8E\u5B66\u672F\u7814\u7A76\uFF1A\u4F8B\u5982\u4E3A\u79D1\u7814\u673A\u6784\u5F00\u5C55\u7EDF\u8BA1\u6216\u5B66\u672F\u7814\u7A76\u4E4B\u5FC5\u8981\uFF1B'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\u57FA\u4E8E\u7B26\u5408\u6CD5\u5F8B\u6CD5\u89C4\u7684\u793E\u4F1A\u516C\u5171\u5229\u76CA\u7B49\u3002'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
              __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
                'font',
                { face: '\u5B8B\u4F53' },
                '\u6211\u4EEC\u4F1A\u901A\u8FC7\u5E94\u7528\u7A0B\u5E8F\u63A5\u53E3\uFF08'
              ),
              'API\uFF09\u3001\u8F6F\u4EF6\u5DE5\u5177\u5F00\u53D1\u5305\uFF08SDK\uFF09\u4E0E\u7B2C\u4E09\u65B9\u8FDB\u884C\u5FC5\u8981\u7684\u6570\u636E\u5171\u4EAB\uFF0C\u4E0D\u540C\u7248\u672C\u7684\u7B2C\u4E09\u65B9SDK\u4F1A\u6709\u6240\u4E0D\u540C\uFF0C \u4E00\u822C\u5305\u62EC\u7B2C\u4E09\u65B9\u8D26\u53F7\u767B\u5F55\u7C7B\u3001\u5206\u4EAB\u7C7B\u3001\u7B2C\u4E09\u65B9\u652F\u4ED8\u7C7B\u3001\u5730\u56FE\u5BFC\u822A\u7C7B\u3001\u5382\u5546\u63A8\u9001\u7C7B\u3001\u7EDF\u8BA1\u7C7B\u3001\u8BED\u97F3\u8BC6\u522B\u7C7B\u7B49\uFF0C\u6211\u4EEC\u4F1A\u5BF9\u7B2C\u4E09\u65B9\u8FDB\u884C\u4E25\u683C\u7684\u5B89\u5168\u68C0\u6D4B\u5E76\u7EA6\u5B9A\u6570\u636E\u4FDD\u62A4\u63AA\u65BD\u3002'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 0pt 0pt 0.0001pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(0, 0, 255); text-decoration: underline; font-size: 10.5pt;', onClick: this.jumpToSdkcontents },
            '\u7F8E\u56E2\u6392\u961F\u63A5\u5165\u7B2C\u4E09\u65B9SDK\u76EE\u5F55'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-family: \u5FAE\u8F6F\u96C5\u9ED1; font-size: 13.5pt;' },
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement('br', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
              '\u8BF7\u60A8\u77E5\u6089\uFF0C\u6211\u4EEC\u4EC5\u4F1A\u51FA\u4E8E\u5408\u6CD5\u3001\u6B63\u5F53\u3001\u5FC5\u8981\u3001\u7279\u5B9A\u3001\u660E\u786E\u7684\u76EE\u7684\u5171\u4EAB\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C \u5BF9\u6211\u4EEC\u4EC5\u4E3A\u5B9E\u73B0\u672C\u653F\u7B56\u4E2D\u58F0\u660E\u7684\u76EE\u7684\u4E0E\u4E4B\u5171\u4EAB\u4E2A\u4EBA\u4FE1\u606F\u7684\u516C\u53F8\u3001\u7EC4\u7EC7\u548C\u4E2A\u4EBA\uFF0C\u6211\u4EEC\u4F1A\u4E0E\u5176\u7B7E\u7F72\u4E25\u683C\u7684\u4FE1\u606F\u4FDD\u62A4\u548C\u4FDD\u5BC6\u534F\u5B9A\uFF0C \u8981\u6C42\u4ED6\u4EEC\u9075\u5B88\u534F\u8BAE\u5E76\u91C7\u53D6\u76F8\u5173\u7684\u5B89\u5168\u63AA\u65BD\u6765\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 0pt 0pt 0.0001pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 12pt;' },
            '\xA0'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\uFF08\u4E8C\uFF09\u8F6C\u8BA9'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
              '\u6211\u4EEC\u4E0D\u4F1A\u5C06\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u8F6C\u8BA9\u7ED9\u4EFB\u4F55\u516C\u53F8\u3001\u7EC4\u7EC7\u548C\u4E2A\u4EBA\uFF0C\u4F46\u4EE5\u4E0B\u60C5\u51B5\u9664\u5916\uFF1A'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement('b', null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '1\u3001\u5728\u83B7\u53D6\u660E\u786E\u540C\u610F\u7684\u60C5\u51B5\u4E0B\u8F6C\u8BA9\uFF1A\u83B7\u5F97\u60A8\u7684\u660E\u786E\u540C\u610F\u540E\uFF0C\u6211\u4EEC\u4F1A\u5411\u5176\u4ED6\u65B9\u8F6C\u8BA9\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF1B'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '2\u3001\u5728\u6211\u4EEC\u53D1\u751F\u5408\u5E76\u3001\u6536\u8D2D\u6216\u7834\u4EA7\u6E05\u7B97\u60C5\u5F62\uFF0C\u6216\u5176\u4ED6\u6D89\u53CA\u5408\u5E76\u3001\u6536\u8D2D\u6216\u7834\u4EA7\u6E05\u7B97\u60C5\u5F62\u65F6\uFF0C\u5982\u6D89\u53CA\u5230\u4E2A\u4EBA\u4FE1\u606F\u8F6C\u8BA9\uFF0C \u6211\u4EEC\u4F1A\u8981\u6C42\u65B0\u7684\u6301\u6709\u60A8\u4E2A\u4EBA\u4FE1\u606F\u7684\u516C\u53F8\u3001\u7EC4\u7EC7\u7EE7\u7EED\u53D7\u672C\u653F\u7B56\u7684\u7EA6\u675F\uFF0C\u5426\u5219\u6211\u4EEC\u5C06\u8981\u6C42\u8BE5\u516C\u53F8\u3001\u7EC4\u7EC7\u548C\u4E2A\u4EBA\u91CD\u65B0\u5411\u60A8\u5F81\u6C42\u6388\u6743\u540C\u610F\u3002'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 0pt 0pt 0.0001pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 12pt;' },
            '\xA0'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\uFF08\u4E09\uFF09\u516C\u5F00\u62AB\u9732'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
              '\u6211\u4EEC\u4E0D\u4F1A\u516C\u5F00\u62AB\u9732\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4F46\u4EE5\u4E0B\u60C5\u51B5\u9664\u5916\uFF1A'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement('b', null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '1\u3001\u57FA\u4E8E\u60A8\u7684\u4E3B\u52A8\u9009\u62E9\u6216\u83B7\u5F97\u60A8\u7684\u660E\u786E\u540C\u610F\uFF0C\u6211\u4EEC\u53EF\u80FD\u4F1A\u516C\u5F00\u60A8\u7684\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F\uFF1B'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '2\u3001\u5982\u679C\u6211\u4EEC\u786E\u5B9A\u60A8\u51FA\u73B0\u8FDD\u53CD\u6CD5\u5F8B\u6CD5\u89C4\u6216\u4E25\u91CD\u8FDD\u53CD\u7F8E\u56E2\u70B9\u8BC4\u76F8\u5173\u534F\u8BAE\u89C4\u5219\u7684\u60C5\u51B5\uFF0C \u6216\u4E3A\u4FDD\u62A4\u7F8E\u56E2\u6392\u961FAPP\u8FD0\u8425\u8005\u53CA\u5176\u5173\u8054\u516C\u53F8\u7528\u6237\u6216\u516C\u4F17\u7684\u4EBA\u8EAB\u8D22\u4EA7\u5B89\u5168\u514D\u906D\u4FB5\u5BB3\u4EE5\u53CA\u7EF4\u62A4\u826F\u597D\u7684\u516C\u5E73\u4EA4\u6613\u73AF\u5883\uFF0C \u6211\u4EEC\u53EF\u80FD\u4F9D\u636E\u6CD5\u5F8B\u6CD5\u89C4\u6216\u7F8E\u56E2\u6392\u961F\u76F8\u5173\u534F\u8BAE\u89C4\u5219\u62AB\u9732\u60A8\u7684\u76F8\u5173\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u4F8B\u5982\u82E5\u60A8\u9500\u552E\u4E0D\u7B26\u5408\u5B89\u5168\u6807\u51C6\u7684\u5546\u54C1\u800C\u4E25\u91CD\u8FDD\u53CD\u7F8E\u56E2\u6392\u961F\u89C4\u5219\u65F6\uFF0C \u6211\u4EEC\u53EF\u80FD\u4F1A\u516C\u5F00\u62AB\u9732\u60A8\u7684\u5E97\u94FA\u4E3B\u4F53\u4FE1\u606F\u4E0E\u76F8\u5173\u5904\u7F5A\u60C5\u51B5\uFF1B'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '3\u3001\u57FA\u4E8E\u6CD5\u5F8B\u7684\u62AB\u9732\uFF1A\u5728\u6CD5\u5F8B\u3001\u6CD5\u5F8B\u7A0B\u5E8F\u3001\u8BC9\u8BBC\u6216\u653F\u5E9C\u4E3B\u7BA1\u90E8\u95E8\u5F3A\u5236\u6027\u8981\u6C42\u7684\u60C5\u51B5\u4E0B\uFF0C\u6211\u4EEC\u53EF\u80FD\u4F1A\u516C\u5F00\u62AB\u9732\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 0pt 0pt 0.0001pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 12pt;' },
            '\xA0'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
              '\u56DB\u3001\u6211\u4EEC\u5982\u4F55\u4FDD\u62A4\u60A8\u4E2A\u4EBA\u4FE1\u606F\u7684\u5B89\u5168'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\u4E3A\u4FDD\u969C\u60A8\u7684\u4FE1\u606F\u5B89\u5168\uFF0C\u6211\u4EEC\u52AA\u529B\u91C7\u53D6\u5404\u79CD\u7B26\u5408\u4E1A\u754C\u6807\u51C6\u7684\u7269\u7406\u3001\u7535\u5B50\u548C\u7BA1\u7406\u65B9\u9762\u7684\u5B89\u5168\u63AA\u65BD\u6765\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C \u9632\u6B62\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u906D\u5230\u672A\u7ECF\u6388\u6743\u8BBF\u95EE\u3001\u516C\u5F00\u62AB\u9732\u3001\u4F7F\u7528\u3001\u4FEE\u6539\u3001\u635F\u574F\u6216\u4E22\u5931\u3002\u6211\u4EEC\u4F1A\u91C7\u53D6\u4E00\u5207\u5408\u7406\u53EF\u884C\u7684\u63AA\u65BD\uFF0C\u4FDD\u62A4\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C \u4F7F\u7528\u52A0\u5BC6\u6280\u672F\u786E\u4FDD\u6570\u636E\u7684\u4FDD\u5BC6\u6027\uFF1B\u4F7F\u7528\u53D7\u4FE1\u8D56\u7684\u4FDD\u62A4\u673A\u5236\u9632\u6B62\u6570\u636E\u906D\u5230\u6076\u610F\u653B\u51FB\uFF1B\u90E8\u7F72\u8BBF\u95EE\u63A7\u5236\u673A\u5236\uFF0C\u786E\u4FDD\u53EA\u6709\u6388\u6743\u4EBA\u5458\u624D\u53EF\u8BBF\u95EE\u4E2A\u4EBA\u4FE1\u606F\uFF1B \u4EE5\u53CA\u4E3E\u529E\u5B89\u5168\u548C\u9690\u79C1\u4FDD\u62A4\u57F9\u8BAD\u8BFE\u7A0B\uFF0C\u52A0\u5F3A\u5458\u5DE5\u5BF9\u4E8E\u4FDD\u62A4\u4E2A\u4EBA\u4FE1\u606F\u91CD\u8981\u6027\u7684\u8BA4\u8BC6\u3002'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 0pt 0pt 0.0001pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 12pt;' },
            '\xA0'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
              '\u5728\u4E0D\u5E78\u53D1\u751F\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u4E8B\u4EF6\u540E\uFF0C\u6211\u4EEC\u5C06\u6309\u7167\u6CD5\u5F8B\u6CD5\u89C4\u7684\u8981\u6C42\uFF0C \u53CA\u65F6\u5411\u60A8\u544A\u77E5\uFF1A\u5B89\u5168\u4E8B\u4EF6\u7684\u57FA\u672C\u60C5\u51B5\u548C\u53EF\u80FD\u7684\u5F71\u54CD\u3001\u6211\u4EEC\u5DF2\u91C7\u53D6\u6216\u5C06\u8981\u91C7\u53D6\u7684\u5904\u7F6E\u63AA\u65BD\u3001\u60A8\u53EF\u81EA\u4E3B\u9632\u8303\u548C\u964D\u4F4E\u98CE\u9669\u7684\u5EFA\u8BAE\u3001\u5BF9\u60A8\u7684\u8865\u6551\u63AA\u65BD\u7B49\u3002 \u6211\u4EEC\u5C06\u53CA\u65F6\u5C06\u4E8B\u4EF6\u76F8\u5173\u60C5\u51B5\u4EE5\u90AE\u4EF6\u3001\u4FE1\u51FD\u3001\u7535\u8BDD\u3001\u63A8\u9001\u901A\u77E5\u7B49\u65B9\u5F0F\u544A\u77E5\u60A8\uFF0C\u96BE\u4EE5\u9010\u4E00\u544A\u77E5\u4E2A\u4EBA\u4FE1\u606F\u4E3B\u4F53\u65F6\uFF0C\u6211\u4EEC\u4F1A\u91C7\u53D6\u5408\u7406\u3001\u6709\u6548\u7684\u65B9\u5F0F\u53D1\u5E03\u516C\u544A\u3002 \u540C\u65F6\uFF0C\u6211\u4EEC\u8FD8\u5C06\u6309\u7167\u76D1\u7BA1\u90E8\u95E8\u8981\u6C42\uFF0C\u4E3B\u52A8\u4E0A\u62A5\u4E2A\u4EBA\u4FE1\u606F\u5B89\u5168\u4E8B\u4EF6\u7684\u5904\u7F6E\u60C5\u51B5'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\u3002'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 0pt 0pt 0.0001pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 12pt;' },
            '\xA0'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'font-size: 10.5pt;' },
              '\u4E94\u3001\u60A8\u5982\u4F55\u7BA1\u7406\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
              '\u60A8\u6709\u6743\u8BBF\u95EE\u3001\u66F4\u6B63\u3001\u5220\u9664\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u6CD5\u5F8B\u6CD5\u89C4\u89C4\u5B9A\u7684\u4F8B\u5916\u60C5\u51B5\u9664\u5916\u3002'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '1\u3001\u60A8\u53EF\u4EE5\u901A\u8FC7\u4EE5\u4E0B\u65B9\u5F0F\u7BA1\u7406\u60A8\u7684\u4FE1\u606F:'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'font-size: 10.5pt;' },
              '\u8D26\u6237\u4FE1\u606F'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\u2014\u2014\u60A8\u53EF\u4EE5\u8BBF\u95EE\u3001\u67E5\u8BE2\u3001\u66F4\u6B63\u60A8\u8D26\u6237\u4E2D\u7684\u4E2A\u4EBA\u8D44\u6599\u53CA\u8D26\u53F7\u4FE1\u606F\uFF0C \u5982\u624B\u673A\u53F7\u3001\u89D2\u8272\u3001\u804C\u4F4D\u3001\u6240\u5C5E\u95E8\u5E97\uFF0C\u4E5F\u53EF\u4EE5\u66F4\u6539\u60A8\u7684\u5BC6\u7801\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u8BBF\u95EE\u7F8E\u56E2\u6392\u961FApp\u5728\u8BBE\u7F6E\u4E2D\u6267\u884C\u6B64\u7C7B\u64CD\u4F5C\u3002'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'font',
              { face: '\u5B8B\u4F53' },
              '\u5982\u679C\u60A8\u65E0\u6CD5\u901A\u8FC7\u4E0A\u8FF0\u94FE\u63A5\u7BA1\u7406\u8FD9\u4E9B\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u60A8\u53EF\u4EE5\u968F\u65F6\u901A\u8FC7\u672C\u9690\u79C1\u653F\u7B56\u4E2D\u63D0\u4F9B\u7684\u53CD\u9988\u65B9\u5F0F\u8054\u7CFB\u6211\u4EEC\u3002\u6211\u4EEC\u5C06\u5728'
            ),
            '15\u5929\u5185\u56DE\u590D\u60A8\u7684\u8BBF\u95EE\u8BF7\u6C42\u3002'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 0pt 0pt 0.0001pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 12pt;' },
            '\xA0'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '2\u3001\u60A8\u53EF\u4EE5\u6539\u53D8\u60A8\u6388\u6743\u540C\u610F\u7684\u8303\u56F4\u6216\u64A4\u56DE\u6388\u6743'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'font',
              { face: '\u5B8B\u4F53' },
              '\u60A8\u53EF\u4EE5\u901A\u8FC7\u5728\u7F8E\u56E2\u6392\u961F'
            ),
            'App\u4E2D\u901A\u8FC7\u76F8\u5E94\u9875\u9762\u63D0\u793A\u8FDB\u884C\u66F4\u6539\u3001\u5220\u9664\u4FE1\u606F\u3001\u66F4\u6539\u9690\u79C1\u8BBE\u7F6E\u6216\u8005\u5728\u7CFB\u7EDF\u4E2D\u5173\u95ED\u8BBE\u5907\u6743\u9650\u529F\u80FD\u7B49\u65B9\u5F0F\u6539\u53D8\u540C\u610F\u8303\u56F4\u6216\u64A4\u56DE\u60A8\u7684\u6388\u6743\u3002'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\u8BF7\u60A8\u7406\u89E3\uFF0C\u5F53\u60A8\u6267\u884C\u4E0A\u8FF0\u64CD\u4F5C\u540E\uFF0C\u6211\u4EEC\u5C06\u65E0\u6CD5\u7EE7\u7EED\u4E3A\u60A8\u63D0\u4F9B\u64A4\u56DE\u540C\u610F\u6216\u6388\u6743\u6240\u5BF9\u5E94\u7684\u670D\u52A1\uFF0C\u4F46\u4E0D\u4F1A\u5F71\u54CD\u6B64\u524D\u57FA\u4E8E\u60A8\u7684\u6388\u6743\u5DF2\u7ECF\u5F00\u5C55\u7684\u4E2A\u4EBA\u4FE1\u606F\u5904\u7406\u3002'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 0pt 0pt 0.0001pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 12pt;' },
            '\xA0'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '3\u3001\u60A8\u53EF\u4EE5\u6CE8\u9500\u8D26\u6237'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\u60A8\u6709\u6743\u6CE8\u9500\u60A8\u7684\u7F8E\u56E2\u6392\u961F\u8D26\u6237\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u8054\u7CFB\u5BA2\u670D\u534F\u52A9\u60A8\u8FDB\u884C\u8D26\u6237\u6CE8\u9500\u3002'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 0pt 0pt 0.0001pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 12pt;' },
            '\xA0'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'font',
              { face: '\u5B8B\u4F53' },
              '\u5982\u679C\u60A8\u65E0\u6CD5\u901A\u8FC7\u4E0A\u8FF0\u65B9\u5F0F\u7BA1\u7406\u8FD9\u4E9B\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u60A8\u53EF\u4EE5\u968F\u65F6\u901A\u8FC7\u672C\u9690\u79C1\u653F\u7B56\u4E2D\u63D0\u4F9B\u7684\u53CD\u9988\u65B9\u5F0F\u8054\u7CFB\u6211\u4EEC\u3002\u6211\u4EEC\u5C06\u5728'
            ),
            '15\u5929\u5185\u56DE\u590D\u60A8\u7684\u8BF7\u6C42\u5E76\u534F\u52A9\u8C03\u6574\u3002\u5728\u60A8\u66F4\u65B0\u6216\u66F4\u6B63\u524D\uFF0C\u6211\u4EEC\u53EF\u80FD\u4F1A\u5148\u8981\u6C42\u9A8C\u8BC1\u60A8\u7684\u8EAB\u4EFD\uFF0C\u7136\u540E\u518D\u5904\u7406\u60A8\u7684\u8BF7\u6C42\u3002'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 0pt 0pt 0.0001pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 12pt;' },
            '\xA0'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
              '\u516D\u3001\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u5982\u4F55\u5728\u5168\u7403\u8303\u56F4\u8F6C\u79FB'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\u6211\u4EEC\u5728\u4E2D\u534E\u4EBA\u6C11\u5171\u548C\u56FD\u5883\u5185\u8FD0\u8425\u4E2D\u6536\u96C6\u548C\u4EA7\u751F\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5B58\u50A8\u5728'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
              '\u4E2D\u56FD\u5883\u5185'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\uFF0C\u4EE5\u4E0B\u60C5\u5F62\u9664\u5916\uFF1A'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '1\u3001\u6CD5\u5F8B\u6CD5\u89C4\u6709\u660E\u786E\u89C4\u5B9A\uFF1B'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '2\u3001\u83B7\u5F97\u60A8\u7684\u660E\u786E\u6388\u6743\uFF1B'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '3\u3001\u60A8\u901A\u8FC7\u4E92\u8054\u7F51\u8FDB\u884C\u8DE8\u5883\u4EA4\u6613\u7B49\u4E2A\u4EBA\u4E3B\u52A8\u884C\u4E3A\u3002'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\u9488\u5BF9\u4EE5\u4E0A\u60C5\u5F62\uFF0C\u6211\u4EEC\u4F1A\u786E\u4FDD\u4F9D\u636E\u672C\u9690\u79C1\u6743\u653F\u7B56\u5BF9\u60A8\u7684\u4E2A\u4EBA\u4FE1\u606F\u63D0\u4F9B\u8DB3\u591F\u7684\u4FDD\u62A4\u3002'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 0pt 0pt 0.0001pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-family: \u5FAE\u8F6F\u96C5\u9ED1; font-size: 13.5pt;' },
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement('br', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
              '\u4E03\u3001\u672A\u6210\u5E74\u4EBA\u7684\u4E2A\u4EBA\u4FE1\u606F\u4FDD\u62A4'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement('b', null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\u7F8E\u56E2\u975E\u5E38\u91CD\u89C6\u5BF9\u672A\u6210\u5E74\u4EBA\u4E2A\u4EBA\u4FE1\u606F\u7684\u4FDD\u62A4\u3002\u6211\u4EEC\u7684\u7F51\u7AD9\u548C\u670D\u52A1\u4E3B\u8981\u9762\u5411\u6210\u4EBA\u3002'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
              '\u5982\u60A8\u4E3A\u672A\u6210\u5E74\u4EBA\u7684\uFF0C\u5EFA\u8BAE\u60A8\u8BF7\u60A8\u7684\u7236\u6BCD\u6216\u76D1\u62A4\u4EBA\u4ED4\u7EC6\u9605\u8BFB\u672C\u9690\u79C1\u6743\u653F\u7B56\uFF0C\u5E76\u5728\u5F81\u5F97\u60A8\u7684\u7236\u6BCD\u6216\u76D1\u62A4\u4EBA\u540C\u610F\u7684\u524D\u63D0\u4E0B\u4F7F\u7528\u6211\u4EEC\u7684\u670D\u52A1\u6216\u5411\u6211\u4EEC\u63D0\u4F9B\u4FE1\u606F'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\u3002'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\u5BF9\u4E8E\u7ECF\u7236\u6BCD\u6216\u76D1\u62A4\u4EBA\u540C\u610F\u4F7F\u7528\u6211\u4EEC\u7684\u4EA7\u54C1\u6216\u670D\u52A1\u800C\u6536\u96C6\u672A\u6210\u5E74\u4EBA\u4E2A\u4EBA\u4FE1\u606F\u7684\u60C5\u51B5\uFF0C\u6211\u4EEC\u53EA\u4F1A\u5728\u6CD5\u5F8B\u6CD5\u89C4\u5141\u8BB8\u3001\u7236\u6BCD\u6216\u76D1\u62A4\u4EBA\u660E\u786E\u540C\u610F\u6216\u8005\u4FDD\u62A4\u672A\u6210\u5E74\u4EBA\u6240\u5FC5\u8981\u7684\u60C5\u51B5\u4E0B\u4F7F\u7528\u3001\u5171\u4EAB\u3001\u8F6C\u8BA9\u6216\u62AB\u9732\u6B64\u4FE1\u606F\u3002'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
              '\u5982\u679C\u6211\u4EEC\u53D1\u73B0\u81EA\u5DF1\u5728\u672A\u4E8B\u5148\u83B7\u5F97\u53EF\u8BC1\u5B9E\u7684\u7236\u6BCD\u6216\u6CD5\u5B9A\u76D1\u62A4\u4EBA\u540C\u610F\u7684\u60C5\u51B5\u4E0B\u6536\u96C6\u4E86\u672A\u6210\u5E74\u4EBA\u7684\u4E2A\u4EBA\u4FE1\u606F\uFF0C\u5219\u4F1A\u8BBE\u6CD5\u5C3D\u5FEB\u5220\u9664\u76F8\u5173\u6570\u636E'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\u3002'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\xA0'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\u516B\u3001'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
              '\u901A\u77E5\u4E0E\u4FEE\u8BA2'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\u4E3A\u7ED9\u60A8\u63D0\u4F9B\u66F4\u597D\u7684\u670D\u52A1\uFF0C\u6211\u4EEC\u7684\u4E1A\u52A1\u5C06\u4E0D\u65F6\u53D8\u5316\uFF0C\u672C\u9690\u79C1\u653F\u7B56\u4E5F\u5C06\u968F\u4E4B\u8C03\u6574\u3002\u672A\u7ECF\u60A8\u660E\u786E\u540C\u610F\uFF0C\u6211\u4EEC\u4E0D\u4F1A\u524A\u51CF\u60A8\u4F9D\u636E\u672C\u9690\u79C1\u653F\u7B56\u6240\u5E94\u4EAB\u6709\u7684\u6743\u5229\u3002 \u6211\u4EEC\u4F1A\u901A\u8FC7\u5728\u6211\u4EEC\u7F51\u7AD9\u3001\u79FB\u52A8\u7AEF\u4E0A\u53D1\u51FA\u66F4\u65B0\u7248\u672C\u6216\u4EE5\u5176\u4ED6\u65B9\u5F0F\u63D0\u9192\u60A8\u76F8\u5173\u5185\u5BB9\u7684\u66F4\u65B0\uFF0C\u4E5F\u8BF7\u60A8\u8BBF\u95EE\u6211\u4EEC\u4EE5\u4FBF\u53CA\u65F6\u4E86\u89E3\u6700\u65B0\u7684\u9690\u79C1\u653F\u7B56\u3002 \u5728\u524D\u8FF0\u60C5\u51B5\u4E0B\uFF0C\u82E5\u60A8\u7EE7\u7EED\u4F7F\u7528\u6211\u4EEC\u7684\u670D\u52A1\uFF0C\u5373\u8868\u793A\u540C\u610F\u63A5\u53D7\u4FEE\u8BA2\u540E\u7684\u672C\u653F\u7B56\u5E76\u53D7\u4E4B\u7EA6\u675F\u3002'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 0pt 0pt 0.0001pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-family: \u5FAE\u8F6F\u96C5\u9ED1; font-size: 13.5pt;' },
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement('br', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
              '\u4E5D\u3001\u5982\u4F55\u8054\u7CFB\u6211\u4EEC'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 10.5pt;' },
            '\u5982\u679C\u60A8\u5BF9\u4E8E\u6211\u4EEC\u7684\u4E2A\u4EBA\u4FE1\u606F\u5904\u7406\u884C\u4E3A\u5B58\u5728\u4EFB\u4F55\u6295\u8BC9\u4E3E\u62A5\u9700\u6C42\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u9690\u79C1\u4FDD\u62A4\u4E13\u7528\u90AE\u7BB1'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'a',
            { href: 'mailto:privacy@meituan.com' },
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'u',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
                'span',
                {
                  'class': '16',
                  style: 'font-family: Calibri; color: rgb(5, 99, 193);'
                },
                'privacy@meituan.com'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 10.5pt;' },
            '\u6216\u662F'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-family: Calibri; font-size: 10.5pt;' },
            'diancan.jiancha@meituan.com'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 10.5pt;' },
            '\u8054\u7CFB\u6211\u4EEC\uFF0C'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 13.5pt;' },
            '\xA0'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            '\u60A8\u8FD8\u53EF\u4EE5\u901A\u8FC7'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
              __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
                'font',
                { face: '\u5B8B\u4F53' },
                '\u6211\u4EEC\u7684\u7F51\u7AD9\u6216\u7F8E\u56E2\u6392\u961F'
              ),
              'App\u4E0A\u7684\u5BA2\u670D\u7CFB\u7EDF\u4E0E\u6211\u4EEC\u8054\u7CFB\uFF0C'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'color: rgb(51, 51, 51); font-size: 10.5pt;' },
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'font',
              { face: '\u5B8B\u4F53' },
              '\u5E76\u4F5C\u5145\u5206\u63CF\u8FF0\uFF0C\u6211\u4EEC\u5C06\u5728\u9A8C\u8BC1\u60A8\u8EAB\u4EFD\u7684'
            ),
            '15\u5929\u5185\u7B54\u590D\u60A8\u7684\u8BF7\u6C42\u5E76\u5C3D\u529B\u89E3\u51B3\u3002\u5982\u679C\u60A8\u5BF9\u6211\u4EEC\u7684\u56DE\u590D\u4E0D\u6EE1\u610F\uFF0C\u7279\u522B\u662F\u8BA4\u4E3A\u6211\u4EEC\u7684\u4E2A\u4EBA\u4FE1\u606F\u5904\u7406\u884C\u4E3A\u635F\u5BB3\u4E86\u60A8\u7684\u5408\u6CD5\u6743\u76CA\uFF0C\u60A8\u8FD8\u53EF\u4EE5\u901A\u8FC7\u5411\u534F\u8BAE\u7B7E\u8BA2\u5730\u5317\u4EAC\u5E02\u671D\u9633\u533A\u4EBA\u6C11\u6CD5\u9662\u63D0\u8D77\u8BC9\u8BBC\u3002'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 0pt 0pt 0.0001pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 10.5pt;' },
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement('br', { clear: 'all', style: 'break-before: page;' })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'p',
            style: 'margin-top: 5pt; margin-bottom: 5pt; font-size: 12pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-family: Helvetica; color: rgb(51, 51, 51); font-size: 12pt;' },
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'font',
              { face: '\u5B8B\u4F53' },
              '\u9644\u5F55\uFF1A'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'p',
            style: 'margin-top: 5pt; margin-bottom: 5pt; font-size: 12pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              {
                'class': '15',
                style: 'font-family: Helvetica; color: rgb(51, 51, 51);'
              },
              '1',
              __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
                'font',
                { face: '\u7B49\u7EBF' },
                '\u3001\u4E2A\u4EBA\u4FE1\u606F\uFF1A\u6307\u4EE5\u7535\u5B50\u6216\u8005\u5176\u4ED6\u65B9\u5F0F\u8BB0\u5F55\u7684\u80FD\u591F\u5355\u72EC\u6216\u8005\u4E0E\u5176\u4ED6\u4FE1\u606F\u7ED3\u5408\u8BC6\u522B\u7279\u5B9A\u81EA\u7136\u4EBA\u8EAB\u4EFD\u6216\u8005\u53CD\u6620\u7279\u5B9A\u81EA\u7136\u4EBA\u6D3B\u52A8\u60C5\u51B5\u7684\u5404\u79CD\u4FE1\u606F\u3002 \u672C\u9690\u79C1\u653F\u7B56\u4E2D\u53EF\u80FD\u6D89\u53CA\u5230\u7684\u4E2A\u4EBA\u4FE1\u606F\u5305\u62EC\u4F46\u4E0D\u9650\u4E8E\uFF1A\u4E2A\u4EBA\u57FA\u672C\u4FE1\u606F\uFF08\u5305\u62EC\u59D3\u540D\u3001\u7535\u8BDD\u53F7\u7801\u3001\u6027\u522B\u3001\u4F4F\u5740\u3001\u751F\u65E5\u7B49\uFF09\uFF1B \u4E2A\u4EBA\u8EAB\u4EFD\u4FE1\u606F\uFF08\u5305\u62EC\u8EAB\u4EFD\u8BC1\u3001\u519B\u5B98\u8BC1\u3001\u62A4\u7167\u3001\u9A7E\u9A76\u8BC1\u7B49\uFF09\uFF1B\u7F51\u7EDC\u8EAB\u4EFD\u6807\u8BC6\u4FE1\u606F\uFF08\u5305\u62EC\u7CFB\u7EDF\u8D26\u53F7\u3001'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
                'font',
                { face: 'Helvetica' },
                'IP'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
                'font',
                { face: '\u7B49\u7EBF' },
                '\u5730\u5740\u3001\u90AE\u7BB1\u5730\u5740\u53CA\u4E0E\u524D\u8FF0\u6709\u5173\u7684\u5BC6\u7801\u3001\u53E3\u4EE4\u3001\u53E3\u4EE4\u4FDD\u62A4\u7B54\u6848\uFF09\uFF1B\u4E2A\u4EBA\u8D22\u4EA7\u4FE1\u606F\uFF08\u5305\u62EC\u94F6\u884C\u8D26\u53F7\u3001\u4EA4\u6613\u548C\u6D88\u8D39\u8BB0\u5F55\u3001\u4FE1\u8D37\u8BB0\u5F55\u4EE5\u53CA\u865A\u62DF\u8D22\u4EA7\u4FE1\u606F\u7B49\uFF09\uFF1B \u4E2A\u4EBA\u5065\u5EB7\u751F\u7406\u4FE1\u606F\uFF08\u5305\u62EC\u75C5\u75C7\u3001\u75C5\u5386\u3001\u75C5\u53F2\u7B49\uFF09\uFF1B\u8054\u7CFB\u4EBA\u4FE1\u606F\uFF08\u5305\u62EC\u901A\u8BAF\u5F55\u4FE1\u606F\u3001\u597D\u53CB\u5217\u8868\u7B49\uFF09\uFF1B\u4E2A\u4EBA\u4E0A\u7F51\u8BB0\u5F55\uFF08\u5305\u62EC\u7F51\u7AD9\u6D4F\u89C8\u8BB0\u5F55\u3001\u70B9\u51FB\u8BB0\u5F55\u7B49\uFF09\uFF1B \u4E2A\u4EBA\u8BBE\u5907\u4FE1\u606F\uFF08\u5305\u62EC\u552F\u4E00\u8BBE\u5907\u8BC6\u522B\u7801\u7B49\u63CF\u8FF0\u4E2A\u4EBA\u5E38\u7528\u8BBE\u5907\u57FA\u672C\u60C5\u51B5\u7684\u4FE1\u606F\uFF09\uFF1B\u4E2A\u4EBA\u4F4D\u7F6E\u4FE1\u606F\uFF08\u5305\u62EC\u884C\u8E2A\u8F68\u8FF9\u3001\u7CBE\u51C6\u5B9A\u4F4D\u4FE1\u606F\u7B49\uFF09\u3002'
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'p',
            style: 'margin-top: 5pt; margin-bottom: 5pt; font-size: 12pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'b',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
              'span',
              {
                'class': '15',
                style: 'font-family: Helvetica; color: rgb(51, 51, 51);'
              },
              '2',
              __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
                'font',
                { face: '\u7B49\u7EBF' },
                '\u3001\u4E2A\u4EBA\u654F\u611F\u4FE1\u606F\uFF1A\u662F\u6307\u4E00\u65E6\u6CC4\u9732\u3001\u975E\u6CD5\u63D0\u4F9B\u6216\u6EE5\u7528\u53EF\u80FD\u5371\u5BB3\u4EBA\u8EAB\u548C\u8D22\u4EA7\u5B89\u5168\uFF0C\u6781\u6613\u5BFC\u81F4\u4E2A\u4EBA\u540D\u8A89\u3001\u8EAB\u5FC3\u5065\u5EB7\u53D7\u5230\u635F\u5BB3\u6216\u6B67\u89C6\u6027\u5F85\u9047\u7B49\u7684\u4E2A\u4EBA\u4FE1\u606F\u3002 \u672C\u9690\u79C1\u653F\u7B56\u4E2D\u53EF\u80FD\u6D89\u53CA\u5230\u7684\u4E2A\u4EBA\u654F\u611F\u4FE1\u606F\u5305\u62EC\uFF1A\u4E2A\u4EBA\u8EAB\u4EFD\u8BA4\u8BC1\u4FE1\u606F\uFF08\u5305\u62EC\u8EAB\u4EFD\u8BC1\u3001\u519B\u5B98\u8BC1\u3001\u62A4\u7167\u3001\u9A7E\u9A76\u8BC1\u3001\u5B66\u751F\u8BC1\u7B49\uFF09\uFF1B \u4E2A\u4EBA\u8D22\u4EA7\u4FE1\u606F\uFF08\u94F6\u884C\u8D26\u53F7\u3001\u4EA4\u6613\u548C\u6D88\u8D39\u8BB0\u5F55\u3001\u4FE1\u8D37\u8BB0\u5F55\u4EE5\u53CA\u865A\u62DF\u8D22\u4EA7\u4FE1\u606F\u7B49\uFF09\uFF1B\u5176\u4ED6\u4FE1\u606F\uFF08\u884C\u8E2A\u8F68\u8FF9\u3001\u901A\u8BAF\u5F55\u4FE1\u606F\u3001\u7CBE\u51C6\u5B9A\u4F4D\u4FE1\u606F\u7B49\uFF09\uFF1B'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
                'font',
                { face: 'Helvetica' },
                '14'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
                'font',
                { face: '\u7B49\u7EBF' },
                '\u5468\u5C81\u4EE5\u4E0B\u7684\u513F\u7AE5\u4FE1\u606F\u3002'
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
          'p',
          {
            'class': 'MsoNormal',
            style: 'margin: 1.5pt 0pt; font-family: \u7B49\u7EBF; font-size: 10.5pt;'
          },
          __WEBPACK_IMPORTED_MODULE_0_react__["default"].createElement(
            'span',
            { style: 'font-size: 10.5pt;' },
            '\xA0'
          )
        )
      );
    }
  }]);

  return Agreement;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Agreement.run();

/***/ }),

/***/ 8:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    env: { // 环境判断
        beta: {
            domain: 'test.i.meituan.com', // 当前域名
            serverDomain: 'queue.test.meituan.com/api', // 当前后端域名
            // serverDomain: 'localhost:8080/api', // 本地调试使用
            rmsDomain: 'rms.sjst.test.meituan.com',
            setLoginCookie: 'm.51ping.com/orderdish/invoice/login/setcookie',
            kdbSSO: 'http://fepassport.sjst.test.sankuai.com/account/unitivelogin?bg_source=1&service=orderdish-invoice-web&continue='
        },
        prd: {
            domain: 'i.meituan.com',
            serverDomain: 'queue.meituan.com/api',
            rmsDomain: 'pos.meituan.com',
            setLoginCookie: 'm.dianping.com/orderdish/invoice/login/setcookie',
            kdbSSO: 'https://epassport.meituan.com/account/unitivelogin?bg_source=1&service=orderdish-invoice-web&continue='
        }
    }
});

/***/ }),

/***/ 9:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getPath;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__env_js__ = __webpack_require__(5);



function getPath() {
    var envName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__env_js__["a" /* default */])();

    // 模块自定义配置
    var envObj = __WEBPACK_IMPORTED_MODULE_0__config_js__["a" /* default */].env[envName];

    return {
        ajax: location.protocol + '//' + envObj.serverDomain,
        rmsAjax: location.protocol + '//' + envObj.rmsDomain,
        serverDomain: location.protocol + '//' + envObj.serverDomain,
        domain: location.protocol + '//' + envObj.domain
    };
}

/***/ })

},[721]);


// WEBPACK FOOTER //
// static/js/useragreement.2f071a0bb519e3d152a3.js